<!--
 * @Author: your name
 * @Date: 2020-08-12 15:18:34
 * @LastEditTime: 2022-12-08 15:42:25
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/TableOrCounter/index.vue
-->
<style scoped lang="sass">
.top
  padding: 0 17px

  .product_price
    margin-bottom: 16px
    font-size: 14px
    font-weight: 500
    color: #334455

.combo_required_box
  .combo_required
    .combo_product
      display: flex
      justify-content: space-between
      align-items: center
      padding: 10px 16px
      border-top: 1px solid rgba(50, 56, 62, .1)

      .combo_product_left
        display: flex
        align-items: center

        .combo_product_img
          width: 62px
          height: 62px
          border-radius: 4px

        .combo_product_content
          margin-left: 10px

          .dish_info_name
            margin-bottom: 6px

          .dish_info_modifications
            display: flex
            font-size: 12px
            color: rgba(51, 68, 85, .75)

            .ellipsis_text
              max-width: 140px
              overflow: hidden
              text-overflow: ellipsis
              white-space: nowrap

          .dish_info_error
            font-size: 12px
            color: #1FC1B9
            font-weight: bold
            text-decoration: underline
            letter-spacing: 0.5px

      .combo_product_right
        ::v-deep
          .material-icons
            color: var(--menu-primary-background-colour) !important

.app_container
  display: flex
  flex-direction: column

  .hide_button
    padding-bottom: 0

  .drawer
    margin-bottom: 10px

    &:last-child
      margin-bottom: 0

  .van-radio,
  .van-checkbox
    padding-right: 18px
    border-bottom: 1px solid #ebecee

    ::v-deep
      .van-radio__label,
      .van-checkbox__label
        font-size: 14px
        color: var(--menu-primary-text-colour)

      .van-radio__label
        display: flex
        justify-content: space-between
        width: 100%

    &:last-child
      border-bottom: 0

  ::v-deep
    .van-collapse-item__content
      padding: 0

  .banner
    margin-bottom: 22px
    width: 100%
    // height: 195px
    // object-fit: cover

  .wrapper
    display: flex
    flex-direction: column

    .wrapper_list
      display: flex
      align-items: center

  .sub_total
    line-height: 12px
    font-size: 12px
    margin-bottom: 6px

    .price
      font-weight: 500

.item_box
  display: flex
  align-items: center
  justify-content: space-between

  .item
    width: 100%
    height: 100%

    .name
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
      width: 170px
      font-size: 14px
      color: var(--menu-primary-text-colour)

    .adjustMoney
      color: #8e96a0
      font-size: 14px

  .recommand_product_img
    width: 50px
    height: 100%
    margin-right: 9px
    border-radius: 5px

::v-deep
  .van-checkbox__label
    flex: 1
</style>

<style lang="sass" scoped>
::v-deep

  .van-stepper__input
    margin: 0 15px
    font-size: 23px
    color: var(--menu-primary-text-colour)

  .van-stepper__minus::before,
  .van-stepper__plus::before
    height: 3px
    border-radius: 3px

  .van-stepper__minus::after,
  .van-stepper__plus::after
    width: 3px
    border-radius: 3px
</style>

<style lang="sass" scoped>
.collapse_box
  position: relative

.wrong_msg
  z-index: 1
  position: absolute
  top: 26px
  font-size: 10px
  line-height: 20px
  color: red
  left: 16px
  background: #f3f3f5
  padding-right: 10px

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour) !important

  .van-stepper--round .van-stepper__plus
    background-color: var(--menu-primary-background-colour) !important

  .van-stepper--round .van-stepper__minus
    border-color: var(--menu-primary-background-colour) !important
    background-color: var(--menu-primary-background-colour) !important

  .van-button--primary
    background-color: var(--menu-primary-background-colour) !important

  .van-checkbox__label
    height: 100%
    margin-left: 0

  .van-checkbox__icon
    display: flex
    justify-content: center
    align-items: center
    height: 100%

  .material-icons
    padding: 18px 15px 18px 18px

.dishes_info
  padding-top: 15px

.contains,
.spicy
  margin-bottom: 16px

.info_text
  margin-bottom: 10px
  padding-right: 21px
  font-size: 12px
  line-height: 12px
  color: var(--menu-primary-text-colour)

.recommand_product_img
  height: 100%
  margin-right: 9px
  border-radius: 5px

.recommand_product
  display: flex
  justify-content: space-between
  align-items: center
  height: 80px
  padding: 9px 0

.dish_info
  flex: 1
  display: flex
  flex-direction: column
  justify-content: center

  .dish_info_modifications
    display: flex
    font-size: 12px
    color: rgba(51, 68, 85, .75)

    .ellipsis_text
      max-width: 140px
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap

.dish_info_name
  margin-bottom: 12px
  line-height: 16px
  font-size: 14px
  color: var(--menu-primary-text-colour)

.dish_info_price
  line-height: 16px
  font-size: 14px
  color: var(--menu-primary-text-colour)

.money
  position: absolute
  bottom: 4px
  right: 0

.recommand_product
  position: relative

  ::v-deep
    .material-icons
      color: var(--menu-primary-background-colour)

.error_red_text
  .dish_info_error
    color: #B00620 !important

.option_number_controls
  display: flex
  align-items: center
  margin-left: 10px

  .number_display
    min-width: 24px
    text-align: center
    font-size: 12px
    font-weight: 500
    color: var(--menu-primary-text-colour)

  .number_btn
    display: flex
    align-items: center
    justify-content: center
    width: 24px
    height: 24px
    border-radius: 50%
    cursor: pointer
    transition: background-color 0.2s

    &.minus_btn
      background-color: #f44
      color: #fff

      &:hover
        background-color: #c00

      .btn_icon
        width: 10px
        height: 2px
        background-color: #fff
        border-radius: 1px

    &.plus_btn
      background-color: var(--menu-primary-background-colour)
      color: #fff

      &:hover
        opacity: 0.8

      .btn_icon
        position: relative
        width: 10px
        height: 2px
        background-color: #fff
        border-radius: 1px

        &::after
          content: ''
          position: absolute
          top: -4px
          left: 4px
          width: 2px
          height: 10px
          background-color: #fff
          border-radius: 1px

    &.disabled
      opacity: 0.4
      cursor: not-allowed

.item_with_number
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%

  .item_content
    flex: 1
    display: flex
    justify-content: space-between
    align-items: center
</style>

<template lang="pug">
.app_container
  .overflow_scroll(:class="{hide_button: isReadOnly}")
    img.banner(v-if="product.id || product.image" :src="localizedImage")
    .top
      .product_price(v-if="isCombo && !hidePriceInDesc") {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ displayPrice(product.price) }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      //- @todo replace true with enableMutipleSize
      .info_text.o(v-if="true && useHtmlDescription" v-html="localizedDescription")
      .info_text.o(v-else-if="true && !useHtmlDescription") {{ localizedDescription }}
      dishes-info.dishes_info(
        v-else
        :price="getProductPrice(product.price)"
        :info="localizedDescription"
      )
      spicy.spicy(
        v-if="product.id"
        :spiceLevel="product.spiceLevel"
        :tags="product.tags"
        :containTags="product.containsTags"
        :seafoodOrigin="product.seafoodOrigin"
      )
      mutiple-size(
        v-show="product.id && product.sizeSettings && product.sizeSettings.mutipleSize"
        ref="mutipleSize"
        :item-list="mutipleSizeSettingsList"
        @choosedItem="choosedItem"
      )
    .combo_required_box(v-if="isCombo")
      .combo_required(v-for="(combo, comboIndex) in requiredComboList" :key="comboIndex")
        .combo_product(v-for="(comboProduct, index) in combo.products" :key="index" :class="{'error_red_text': !isPassValidate && verificationComboRequired(comboProduct.detail, comboIndex, index)}")
          .combo_product_left
            img.combo_product_img(:src="getComboProductSrc(comboProduct.id)")
            .combo_product_content
              .dish_info_name {{ getLocalizedComboProductName(comboProduct.id) }}
              .dish_info_price.o6 {{ getRequiredProductPrice(comboProduct) }}
              .dish_info_modifications(v-if="!verificationComboRequired(comboProduct.detail, comboIndex, index) && comboModifications(comboProduct, combo.id)")
                .ellipsis_text ({{ comboModifications(comboProduct, combo.id) }}
                span )
              .dish_info_error.p(@click.stop="editMutipleSize(comboProduct, comboIndex, null, null, index)") {{ verificationComboRequired(comboProduct.detail, comboIndex, index) }}
          .combo_product_right.p(v-if="showComboRequiredEditIcon(comboProduct)")
            icon(size="25" @click.stop="editMutipleSize(comboProduct, comboIndex, null, null, index)") create
          .combo_product_right.p(v-else)
            icon(size="25" @click.stop="editMutipleSize(comboProduct, comboIndex, null, null, index)") visibility

    .collapse_box.drawer.upgrades_box(v-if="product.upgradeProducts && product.upgradeProducts.items && product.upgradeProducts.items.length")
      collapse(:title="product.upgradeProducts.title")
        van-checkbox(
          v-for="(item, chooseIndex) in product.upgradeProducts.items"
          :key="item.id"
          :name="getLocalizedUpgradeName(item)"
          :value="item.checked"
          @click.stop="chooseUpgradeProducts(chooseIndex)"
          label-disabled
        )
          .item_box
            img.recommand_product_img(:src="getLocalizedUpgradeImage(item)")
            .item
              .name {{ getLocalizedUpgradeName(item) }}
              .adjustMoney(v-if="parseFloat(item.price)")
                span.mark(v-if="symbolPosition !== 'after'") {{ parseFloat(item.price) < 0 ? '-' : '+' }}{{ currencySymbol }}
                span.mark(v-else) {{ parseFloat(item.price) < 0 ? '-' : '+' }}
                span.just_price {{ displayAbsPrice(item.price) }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
            icon.dish_info_choosed.p(size="25" color="rgb(20, 196, 188)" @click.stop="onUpgradeProductsIcon(item, chooseIndex)") visibility
          template(#icon="props")
            icon(v-if="props.checked" :color="primaryColor") radio_button_checked
            icon(v-if="!props.checked" :color="primaryColor") radio_button_unchecked

    .collapse_box.drawer(
      v-for="(each, index) in product.modifications"
      v-if="getIsCombo(each.isCombo)"
      :key="String(each.id) + String(index)"
    )
      .wrong_msg(v-if="each.wrong") {{ each.wrong }}
      collapse(
        v-if="each.id && each.options.some(item => !item.unShow) && each.unShow !== true"
        :title="getLocalizedModName(each)"
        :desc="getDesc(each)"
        :name="index"
        :index="enableModCollapse && each.type === 'optional' && each.recommendationType !== true ? '' : index"
        :id="parseInt(each.id)"
        :open="isSectionOpen(each)"
        :lock-open="isSectionLocked(each)"
      )
        van-checkbox(
          v-for="(item, chooseIndex) in each.options"
          :key="item.id"
          :name="getLocalizedOptName(item)"
          :value="item.checked"
          v-if="isSinglePickSection(each) && !item.unShow"
          :disabled="item.disabled"
          @click="getCheckNum(index, chooseIndex)"
          @input="handleCheckBoxChoose($event, each, item, index, chooseIndex)"
        )
          .item(v-if="!(each.id < 0)")
            .name {{ getLocalizedOptName(item) }}
            .adjustMoney(v-if="parseFloat(item.adjustPrice)")
              span.mark(v-if="symbolPosition !== 'after'") {{ each.removeType ? '-' : '+' }}{{ currencySymbol }}
              span.mark(v-else) {{ each.removeType ? '-' : '+' }}
              span.just_price {{ displayAbsPrice(item.adjustPrice) }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
          .recommand_product(v-else)
            img.recommand_product_img(:src="getRecommandProductSrc(item.id)")
            .dish_info
              .dish_info_name {{ getLocalizedRecommandProductName(item.id) }}
              .dish_info_price.o6(v-if="!each.isCombo") {{ getRecommandProductPrice(item.id) }}
              .dish_info_price.o6(v-else) {{ getRequiredProductPrice(item) }}
              .dish_info_modifications(v-if="comboModifications(item, each.id)")
                .ellipsis_text ({{ comboModifications(item, each.id) }}
                span )
              .dish_info_price.o6(v-if="!each.isCombo") {{ getRecommandProductPrice(item.id) }}
            .money(v-if="item.adjustPrice > 0") {{ symbolPosition === 'after' ? '' : currencySymbol + ' ' }}{{ displayPrice(item.adjustPrice) }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
            icon.dish_info_choosed.p(v-if="item.checked && choosedMutipleSize(item.id, each)" @click.stop="editMutipleSize(item, null, chooseIndex, index)" size="25") create
            icon.dish_info_choosed.p(v-if="item.checked && !choosedMutipleSize(item.id, each)" @click.stop="editMutipleSize(item, null, chooseIndex, index)" size="25") visibility
          template(#icon="props")
            icon(v-if="props.checked && each.type === 'required'" :color="primaryColor") radio_button_checked
            icon(v-if="!props.checked && each.type === 'required'" :color="primaryColor") radio_button_unchecked
            icon(v-if="props.checked && each.type !== 'required'" :color="primaryColor") check_box
            icon(v-if="!props.checked && each.type !== 'required'" :color="primaryColor") check_box_outline_blank

        van-checkbox(
          v-for="(item, chooseIndex) in each.options"
          v-if="!isSinglePickSection(each) && !item.unShow"
          :key="item.id"
          :name="getLocalizedOptName(item)"
          :value="item.checked"
          :disabled="item.disabled"
          @click="handleOptionClick(index, chooseIndex, each, item)"
          @input="handleMultiCheckBoxInput($event, each, item, index, chooseIndex)"
        )
          //- each.id < 0，说明是推荐菜（-1 手动，-2/-3 AI）
          .item_with_number(v-if="!(each.id < 0)")
            .item_content
              .name {{ getLocalizedOptName(item) }}
              .adjustMoney(v-if="parseFloat(item.adjustPrice)")
                span.mark(v-if="symbolPosition !== 'after'") {{ each.removeType ? '-' : '+' }}{{ currencySymbol }}
                span.mark(v-else) {{ each.removeType ? '-' : '+' }}
                span.just_price {{ displayAbsPrice(item.adjustPrice) }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
            .option_number_controls(v-if="item.checked && !isRadioSelect(each)")
              .number_btn.minus_btn(@click.stop="decreaseNumber(index, chooseIndex, each, item)")
                .btn_icon
              .number_display {{ getOptionDisplayNumber(item) }}
              .number_btn.plus_btn(:class="{ disabled: !canIncrease(item, each) }" @click.stop="increaseNumber(index, chooseIndex, each, item)")
                .btn_icon
          .recommand_product(v-else)
            img.recommand_product_img(:src="getRecommandProductSrc(item.id)")
            .dish_info
              .dish_info_name {{ getLocalizedRecommandProductName(item.id) }}
              .dish_info_price.o6(v-if="!each.isCombo") {{ getRecommandProductPrice(item.id) }}
              .dish_info_price.o6(v-else) {{ getRequiredProductPrice(item) }}
              .dish_info_modifications(v-if="comboModifications(item, each.id)")
                .ellipsis_text ({{ comboModifications(item, each.id) }}
                span )
            .money(v-if="Number(item.adjustPrice) && item.isCombo") {{ symbolPosition === 'after' ? '' : currencySymbol + ' ' }}{{ displayPrice(item.adjustPrice) }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
            icon.dish_info_choosed.p(
              v-if="item.checked && choosedMutipleSize(item.id, each)"
              size="25"
              @click.stop="editMutipleSize(item, null, chooseIndex, index)"
            ) create
            icon.dish_info_choosed.p(
              v-if="item.checked && !choosedMutipleSize(item.id, each)"
              size="25"
              @click.stop="editMutipleSize(item, null, chooseIndex, index)"
            ) visibility
          template(#icon="props")
            icon(v-if="props.checked" :color="item.disabled ? blank : primaryColor") check_box
            icon(v-else :color="item.disabled ? blank : primaryColor") check_box_outline_blank
  .footer_box(v-if="!isReadOnly")
    footer-bar.ns.footer_bar_absolute(
      v-if="isVenueOpenTime || onlineDisabledButton"
      :status="isVenueOpenTimeFooterBarStatus"
      :disabled="disabledAddCartButton"
      @clickButton="addCart"
    )
      template(v-slot:price)
        .sub_total(v-if="!disabledAddCartButton")
          span.f3.ls1 {{ t('subtotal', 'Subtotal:') }}
          span.price.ls1 {{ symbolPosition === 'after' ? ' ' : ' ' + currencySymbol }}{{ displayPrice(total ? total * product.num : 0) }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      template(v-slot:left)
        van-stepper(v-model="product.num" theme="round" button-size="28px" disable-input)
    footer-bar.ns.footer_bar_absolute(v-else :status="5" :disabled="true" @clickButton="addCart")
      template(v-slot:left)
        van-stepper(v-model="product.num" theme="round" button-size="28px" disable-input)

  Product-bottom-popup-dialog(
    v-model="showChooseRecommandProductMutipleSizeDialog"
    :round="false"
    isFixed
  )
    template(v-slot:popup-dialog)
      recommand-product-mutiple-size-content(
        ref="recommandProductMutipleSizeContent"
        :show="showChooseRecommandProductMutipleSizeDialog"
        :product="recommandProduct"
        :isCombo="isCombo"
        :isEdit="recommandIsEdit"
        :isPosEnable="posStatus && posStatus.posName === 'simphony'"
        @chooseRecommandMutipleSize="chooseRecommandMutipleSize"
        @chooseProductIntroduction="showChooseRecommandProductMutipleSizeDialog = false"
      )

  //- Create one more component to prevent more 'if else'
  //- 多创建一个组件，防止更多的 if else
  bottom-popup-dialog(
    v-model="showUpgradeProductDialog"
    :round="false"
    isFixed
  )
    template(v-slot:popup-dialog)
      //- 'isUpgradeProducts' adds a unique representation, proving it is an upgraded product
      //- isUpgradeProducts 添加唯一标识，证明是升级商品
      recommand-product-mutiple-size-content(
        ref="recommandProductUpgradeContent"
        :show="showUpgradeProductDialog"
        :isUpgradeProducts="true"
        :product="upgradeProductData"
        @chooseUpgradeProduct="chooseUpgradeProducts"
        @chooseProductIntroduction="showUpgradeProductDialog = false"
      )
</template>

<script>
import dayjs from 'dayjs'
import Component, { mixins } from 'vue-class-component'
import { _setProduct, } from '@/modules/store'
import Collapse from 'components/Collapse'
import Spicy from './component/Spicy'
import ContainTags from './component/ContainTags'
import MutipleSize from './component/MutipleSize'
import { mapState } from 'vuex'
import { getProduct } from 'api/product'
import { _isOpenStatus, safeDecodeURI } from 'utils'
import { menuIdFor, withMenuId } from '@/utils/menu/qrMenu'
import { isMenuGoneError, readWithMenuRetry } from '@/utils/menu/menuRead'
import { reresolveMenu } from '@/utils/menu/reresolveMenu'
import { productReadFailedText } from '@/utils/menu/menuChanged'
import { createMessageDialog } from '@/utils/request/messageDialog'
import resizeHandler from '@/utils/resizeHandler'
import mixin from '@/utils/mixin'
import RecommandProductMutipleSizeContent from './component/RecommandProductMutipleSizeContent'
import ProductBottomPopupDialog from './component/BottomPopupDialog'
import { convertPrice, formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'
import { getLocalizedField, getLocalizedModificationName, getLocalizedOptionName, t, tParams } from '@/utils/language'
import {
  calcSelectedTotal,
  canIncreaseOption,
  decreaseOptionNumber,
  getOptionDisplayNumber as getOptionDisplayNumberFn,
  increaseOptionNumber,
  isRadioSelect as isRadioSelectFn
} from './utils/modOptionNumber'
import {
  applySectionSelectionLimits,
  applySingleSelectExclusive,
  isOptionHidden,
  isSectionLocked as isModSectionLocked,
  isSectionOpen as isModSectionOpen,
  resolveEditCollapse,
  resolveOptionSelection,
  sectionDefaultAllowance,
  sectionIsSingleSelect,
  sectionLimitKind,
  sectionLowerBound,
  sectionMaxOption
} from './utils/modSectionState'
import { comboRequiredCopy, limitWrongCopy, rangeWrongCopy, sectionPickDesc } from './utils/sectionDesc'
import { productHasUnpickableRequiredSection } from './utils/productDisplay'
import { recommendNeedsCustomise } from './utils/recommendCustomise'
import { trackFunnelEvent } from 'utils/funnelTracking'

@Component({
  mixins: [resizeHandler],

  filters: {
    fix (val) {
      return formatDecimalNumber(parseFloat(val))
    }
  },

  props: {
    number: [String, Number],
    productId: [String, Number],
  },

  components: {
    Collapse,
    Spicy,
    ContainTags,
    MutipleSize,
    RecommandProductMutipleSizeContent,
    ProductBottomPopupDialog
  },

  async created() {
    // Manage the isIframeCondition added in the background to distinguish the iframe environment
    // 管理后台添加的 isIframeCondition 来区别 iframe 环境
    this.isIframeCondition = this.$route.query.isIframeCondition
    this._addDisabledJumpButton()
    // If it is iframe
    // 如果是 iframe
    if (this.isIframeCondition) {
      const self = this
      window.addEventListener('message', async function(e) {
        if (e.data.name === 'dataToMobileIframe') {
          self.disabledButton = true
          const addNumData = {
            ...e.data.data,
            num: 1
          }
          const productData = self._getAddRecommandProduct(addNumData)
          self.saveProductName(productData.name)
          self.product = productData
          self._applyDefaultSelectionLimits()
          self._getChoosedRecommandProductMutipleSizeInfo()
          if (self.product.type === 'combo') {
            self._formatComboProduct()
            self._getComboProductList()
          }
          self._getProductRequiredModificationsIndex()
          await self._getRecommandProductList()
          self.$store.commit('closeLoading')
        }
      })
    } else {
      if (this.isMobile) this.$store.commit('showLoading')
      await this.__checkVenueOpenTime()
      await this.getData()
      // productId === undefined, Description is not to edit products
      // productId === undefined，说明不是编辑商品
      const productId = this.$route.query.productId
      if (this.product.type === 'combo') {
        if (typeof productId === 'undefined') {
          this._formatComboProduct()
          this._getComboProductList()
        } else {
          this.comboProductList = this.product.comboProductList
        }
        this._getRequiredComboList()
      }
      await this._getRecommandProductList()
      this._getProductRequiredModificationsIndex()
      if (!this.recommandProductNum) { this.$store.commit('closeLoading') }
      this.isMobile ? this.$store.commit('closeLoading') : this.$emit('showMuseLoading', false)
    }
  },

  mounted() {
    this._sendMsgToBacken()
    if (this.isMobile) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  },

  computed: {
    ...mapState(['venueId']),
    ...mapState({
      routerInfo: state => state.venueHome.routerInfo,
      isOnline: state => state.app.isOnline,
      onlineDisabledButton: state => state.app.onlineDisabledButton,
      modificationDescSettings: state => state.modificationDescSettings,
      currentLanguage: state => state.language?.currentLanguage,
      currentCurrency: state => state.currencySettings?.currentCurrency,
    }),

    /**
     * @returns {Boolean} Is the current read-only mode
     */
    /**
     * @returns {Boolean} 当前是否是只读模式
     */
    isReadOnly() {
      // The url contains'/r/v/', indicating that it is read-only
      // url 中带有 '/r/v/'，说明是只读模式
      return this.$route.path.includes('/r/v/')
    },

    hidePriceInDesc() {
      return this.product.hidePriceInDesc ?? false
    },

    /**
     * @returns {Boolean} Is it currently a package product
     */
    /**
     * @returns {Boolean} 当前是否是套餐商品
     */
    isCombo() {
      return this.product.type === 'combo'
    },

    enableModCollapse() {
      return this.$store.state.venueHome?.venueGroupSettings?.enableCollapseProductModification ?? false
    },

    /**
     * @returns {Array} When editing a product, obtain the selection information of this product in vuex
     */
    /**
     * @returns {Array} 编辑商品时，获取 vuex 中此商品的选择信息
     */
    proList() {
      return this.$store.state.productList.filter(item => item.venueId === this.venueId)
    },

    /**
     * @returns {Number} Price of upgraded products
     */
    /**
     * @returns {Number} 升级商品的价格
     */
    upgradeProductsPrice() {
      return this.product?.upgradeProducts?.items?.find(item => item.checked)?.price ?? 0
    },

    /**
     * @returns {Boolean} Describe whether to use html
     */
    /**
     * @returns {Boolean} 描述是否使用 html
     */
    useHtmlDescription() {
      return this.product?.settings?.useHtmlDescription ?? false
    },

    /**
     * @returns {Number} Total price of goods
     */
    /**
     * @returns {Number} 商品的总价格
     */
    total() {
      if (this.product.id) {
        let price = 0
        // Calculate Base Price
        // 计算基础价格
        const isMutipleSizeModel = this.choosedItemInfo?.price && this.choosedItemInfo?.name
        if (isMutipleSizeModel) {
          price = parseFloat(this.choosedItemInfo.price)
        } else {
          // If it is not edit product
          // 如果不是 edit product
          price = parseFloat(this.product.price)

          // If it is edit product
          // 如果是 edit product
          const productId = this.$route.query.productId
          if (productId !== undefined) price = parseFloat(this.product.singlePrice)
        }
        // Price of modifications and recommendations
        // 配菜与推荐菜价格
        let adjustMoney = 0
        this.product.modifications.forEach(item => {
          item.options.forEach(each => {
            if (each.checked) {
              if (item.id < 0) {
                adjustMoney = adjustMoney + parseFloat(this.recommendedDishesForGeneralCommodities(each))
              }
              // The combo now has modifications, so the price is directly calculated here
              // 套餐现在也有配菜了，所以在这里直接计算价格
              // 配菜价格需要乘以选项数量 (number)
              // Modification price should be multiplied by option number
              adjustMoney = adjustMoney + parseFloat(each.adjustPrice ?? 0) * (each.number || 1)
              // Price calculation of single modification of combo
              // combo 套餐，单品配菜的价格计算
              if (each.detail) {
                // 同一条记录不许被两格共用：重复子品按 id 取时，两格算的都是第一格的
                // 配菜差价（第二格自己加的钱一分都收不到）。见 `_comboProductForSlot`。
                const comboProduct = this._comboProductForSlot(each)
                if (!comboProduct) return
                comboProduct.modifications.forEach(modification => {
                  modification.options.forEach(option => {
                    if (option.checked) {
                      adjustMoney = adjustMoney + parseFloat(option.adjustPrice ?? 0) * (option.number || 1)
                    }
                  })
                })
              } else if (this.product.type !== 'combo') {
                // Calculation of modifications for ordinary products
                // 普通商品的配菜计算
                // adjustMoney = adjustMoney + parseFloat(each.adjustPrice ?? 0)
              }
            }
          })
        })
        return (price + adjustMoney + this.upgradeProductsPrice)
      }
    },

    // Calculate the total price of recommendations
    // 计算推荐菜总价格
    recommandProductPrice () {
      if (this.product.id) {
        const currentRecommandProductList = this.product.modifications.filter(item => item.id < 0 && !item.isCombo)
        let adjustMoney = 0
        currentRecommandProductList.forEach(item => {
          item.options.forEach(each => {
            if (each.checked) {
              const currentRecommandProduct = this.recommandProductList.find(item => item.id === each.id)
              let basePrice = 0
              if (currentRecommandProduct?.selectSize?.name) {
                basePrice = parseFloat(currentRecommandProduct?.selectSize?.price ?? 0)
              } else {
                basePrice = parseFloat(currentRecommandProduct?.price ?? 0)
              }
              basePrice += this.recommendedDishesForGeneralCommodities(currentRecommandProduct)
              // if (currentRecommandProduct?.modifications) {
              //   currentRecommandProduct.modifications.forEach(item => {
              //     item.options.forEach(each => {
              //       if (each.checked) basePrice += parseFloat(each?.adjustPrice ?? 0)
              //     })
              //   })
              // }
              adjustMoney += basePrice
            }
          })
        })
        return adjustMoney
      }
    },

    productGroupId() {
      return this.$route.query.productGroupId
    },

    productGroupCourse() {
      return this.$route.query.productGroupCourse
    },

    primaryColor() {
      return this.$store.state.app.color.menu_primary_background_colour
    },

    unPassIndexList() {
      return this.requiredIndexList.filter(key => !this.passList.includes(key))
    },

    enableMutipleSize() {
      return this.product.sizeSettings?.mutipleSize ?? false
    },

    choosedMutipleSizeItem() {
      return this.choosedItemInfo.price && this.choosedItemInfo.name
    },

    isVenueOpenTimeFooterBarStatus() {
      const enableMutipleSize = 7
      const nomal = 2
      return this.enableMutipleSize && this.disabledAddCartButton
        ? enableMutipleSize
        : nomal
    },

    disabledAddCartButton() {
      if (this.onlineDisabledButton) return true
      // 必选配菜组里一样都选不了的商品：加不进购物车（owner 2026-08-10 裁定）。
      //
      // 菜单列表已经把这种商品挡在展示之外（venue-home 的 `controlProducts`、
      // 以及购物车推荐位），所以走到这里的只剩**绕过展示层**的路：分享出去的
      // 深链接、iframe 嵌入、改单回填。那几条一条都不过菜单那道门 ——
      // 要么直接读 URL 上的 productId，要么直接从本地存着的购物车里取一行。
      //
      // 这里是 **fail-closed**：按钮直接置灰，而不是让顾客点了没反应，
      // 也不是让一个「必选组没人填」的行静默进单子（厨房会收到缺一项选择的单）。
      // 刻意**不做**「自动跳回菜单」：深链接常常是冷启动，`$router.back()`
      // 会把人送出站外；而本仓的菜单路由有 sp / online / table 好几种形态，
      // 在这里拼一个返回地址只会拼错。
      if (productHasUnpickableRequiredSection(this.product)) return true
      return this.enableMutipleSize
        ? !this.choosedMutipleSizeItem
        : false
    },

    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },

    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    },

    mutipleSizeSettingsList() {
      return this.product.sizeSettings?.settings ?? []
    },

    recommandProduct() {
      return (
        this.currentEditComboProduct ??
          (this.isChooseCombo
            ? this.comboProductList.find(item => item.id === this.clickItemId)
            : this.recommandProductList.find(item => item.id === this.clickItemId))
      )
    },
  },

  watch: {
    showChooseRecommandProductMutipleSizeDialog(val) {
      this.$nextTick(_ => {
        // In the edit product scenario, when the recommandProductMutipleSizeContent pop-up window appears, pre fill the previous options
        // edit 商品场景下，出现 recommandProductMutipleSizeContent 弹窗时，预填写之前的选项
        if (val) {
          this.$refs.recommandProductMutipleSizeContent._setDefault()
          if (this.$refs.recommandProductUpgradeContent) this.$refs.recommandProductUpgradeContent._setDefault()
        } else {
          this.recommandIsEdit = false
        }
      })
    },
    // When language changes, update the nav title with localized product name
    // 语言切换时，使用本地化的商品名称更新导航标题
    currentLanguage() {
      if (this.product && this.product.name) {
        const localizedName = getLocalizedField(this.product, 'name') || this.product.name
        this.saveProductName(localizedName)
      }
    }
  }
})

class productDetail extends mixins(mixin) {
  // Localization computed properties / 本地化计算属性
  get localizedDescription() {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(this.product, 'description') || this.product.description
  }

  get localizedImage() {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(this.product, 'image') || this.product.image
  }

  // Translation helper / 翻译辅助函数
  t(key, fallback) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  // Convert price for display (reactive to currency changes) / 转换价格用于显示（响应货币变化）
  displayPrice(price) {
    const _currency = this.currentCurrency // eslint-disable-line no-unused-vars
    return formatDecimalNumber(convertPrice(parseFloat(price) || 0))
  }

  // Convert and format absolute price value for display / 转换并格式化绝对价格值用于显示
  displayAbsPrice(price) {
    const _currency = this.currentCurrency // eslint-disable-line no-unused-vars
    const val = parseFloat(price) || 0
    return formatDecimalNumber(convertPrice(val < 0 ? -val : val))
  }

  // Get localized modification name / 获取本地化的修改项名称
  getLocalizedModName(modification) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedModificationName(modification) || modification.name
  }

  // Get localized option name / 获取本地化的选项名称
  getLocalizedOptName(option) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedOptionName(option) || option.name
  }

  // Get localized upgrade product name / 获取本地化的升级商品名称
  getLocalizedUpgradeName(item) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(item, 'name') || item.name
  }

  // Get localized upgrade product image / 获取本地化的升级商品图片
  getLocalizedUpgradeImage(item) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(item, 'image') || item.image
  }

  showChooseRecommandProductMutipleSizeDialog = false
  recommandIsEdit = false
  clickItemId = null
  firstIndex = null
  secondIndex = null
  productIntroductionData = {}
  choosedItemInfo = {
    price: null,
    name: null,
    default: null,
    shortName: null,
    index: null,
  }

  showChooseProductIntroductionSizeDialog = false
  showUpgradeProductDialog = false
  isChooseCombo = false // Is the combo product being selected?   // 选择的是不是 combo 商品
  isIframeCondition = false
  disabledButton = false
  recommandProductNum = 0
  comboRequiredIndex = null
  // 正在编辑的那个必选子品在**组内**的下标。`comboRequiredIndex` 只到组，
  // 一个 oneProduct 组可以带多个固定子品（份数靠**重复条目**承载，见
  // `_comboRequiredOptionIndex`），所以顾客选的东西写回哪一格全靠这一半。
  comboRequiredProductIndex = null
  requiredIndexList= []
  comboProductList = []
  recommandProductList = []
  recommandItemsChecked = false // It can be set to check command product items by default   // 可以设置为默认勾选 recommand product items
  blank = ''
  chooseList = ''
  product = {}
  upgradeProductData = {}
  passList = []
  comboProducts = []
  isPassValidate = true // Verify by adding shopping cart   // 是否通过添加购物车校验
  currentEditComboProduct = null
  requiredComboList = []

  /**
   * Check the upgraded products
   * Click the upgrade product icon to confirm the addition
   * @param productsIndex {Number} Subscript of the selected item
   */
  /**
   * 勾选升级商品
   * 点击升级商品 icon 确认添加之后
   * @param productsIndex {Number} 选中商品的下标
   */
  chooseUpgradeProducts(productsIndex, isUpgradeProducts = false) {
    this.product.upgradeProducts.items.forEach((item, index) => {
      if (!isUpgradeProducts) { // Click the radio box   // 点击单选框
        item.checked = productsIndex === index ? !item.checked : false
      } else { // Click the icon of the product   // 点击商品 icon 图标
        item.checked = productsIndex === index
      }
    })
  }

  /**
   * Expand the pop-up window of upgrade product details
   * @param item {Object} Product information you want to view
   * @param chooseIndex {Number} The subscript of the item you want to view
   */
  /**
   * 展开升级商品的详情弹窗
   * @param item {Object} 想要查看的商品信息
   * @param chooseIndex {Number} 想要查看的商品下标
   */
  onUpgradeProductsIcon(item, chooseIndex) {
    this.showUpgradeProductDialog = true
    this.upgradeProductData = {
      ...item,
      index: chooseIndex
    }
  }

  /**
   * Combo products, showing the list of modifications of the required items
   * @param productInfo {Object} Commodity Details
   * @param id {Number, String} The ID of the product group. When id===- 1, it indicates that it is a recommended dish or an optional dish of combo
   * @return {String} Copy of side dishes list of required items
   */
  /**
   * combo 商品，展示必选单品的配菜列表
   * @param productInfo {Object} 商品详情
   * @param id {Number, String} 商品分组的 id。 id === -1 时，说明是推荐菜或者是 combo 的可选菜品
   * @return String 必选单品的配菜列表的文案
   */
  comboModifications(productInfo, id) {
    let text = ''
    if (productInfo.checked) {
      const modifications = productInfo.detail?.modifications ?? []
      modifications.forEach(item => {
        item.options.forEach(option => {
          if (option.checked) {
            const optName = getLocalizedOptionName(option) || option.name
            if (text) text += `, ${optName}`
            else text += optName
          }
        })
      })
    }
    return text
  }

  /**
   * 这个必选子品**真正会随单进购物车**的那份配置。
   *
   * 闸门与写入必须读同一个对象，否则「闸门放行的」与「厨房收到的」不是一回事。
   * `requiredComboList[g].products[p]` 是 `_getRequiredComboList` **map 出来的
   * 新对象**，只用来画屏幕；进购物车的是 `_saveComboProductList` →
   * `_addEachComboProductToCart` 读的 `product.modifications[g].options[p].detail`
   * —— 两份对象图互不相通。而 `requiredComboList[g].options` 与
   * `product.modifications[g].options` 是**同一个数组**（`{...item}` 是浅拷贝），
   * 所以从这里能取到那份真货。
   *
   * @param index {Number} 必选组在 requiredComboList 里的下标
   * @param productIndex {Number} 子品在组内的下标
   * @return {Object|undefined} 随单进购物车的那份 detail；取不到时由调用方回落
   */
  _comboRequiredCartDetail(index, productIndex) {
    if (typeof index !== 'number' || typeof productIndex !== 'number') return undefined
    const group = (this.requiredComboList ?? [])[index]
    const options = group?.options ?? group?.products ?? []
    return options[productIndex]?.detail
  }

  /**
   * Verify whether the required modifications of combo single product is passed
   * @param detail {Object} Details of single product
   * @param index {Number} Subscript of the required group
   * @param productIndex {Number} Subscript of the sub product inside that group
   * @return {String} Text of error prompt
   */
  /**
   * 验证 combo 单品必填配菜是否通过
   * @param detail {Object} 单品的详细信息（取不到"随单那份"时的回落）
   * @param index {Number} 必选组（oneProduct 组）的下标
   * @param productIndex {Number} 该子品在组内的下标
   * @return {String} 错误提示的文案
   */
  verificationComboRequired(detail, index = null, productIndex = null) {
    // 判据是**这一格自己的内容**，不是「顾客点开过这个弹层并按了确认」。
    //
    // 以前这里是一张按下标发的通行证（`comboRequiredPassList`）：发过票就放行。
    // 票记的是「按过确认」，不是「这个子品自己那格选够了」，于是
    //   (a) 写入落到别的格子上时，票照发、闸门照放，厨房收到的那件仍然缺配菜；
    //   (b) 顾客被迫把同一件配第二遍，另一件永远没人管。
    // 票是代理指标，内容才是事实 —— 所以这里只问内容。
    const source = this._comboRequiredCartDetail(index, productIndex) ?? detail
    const modifications = source?.modifications ?? []
    let num = 0
    // 还差几样没选 / how many picks are still missing
    modifications.forEach(item => {
      if (item.type !== 'required') return
      const options = item.options ?? []
      // 一样都点不到的组（空组，或选项全是 `unShow`）：弹层自己那道
      // `_validateRequiredModifications` 也放行（`!options.every(o => o.unShow)`），
      // 这里跟着放行 —— 否则这个套餐会变成**永远加不进购物车**。
      // 这种商品本来就不该摆出来，那道门在 utils/productDisplay。
      //
      // ⚠️ 已知的一处不对称，两半读的不是同一份 `unShow`：屏幕读的是
      // `_getRequiredComboList` map 出来的副本（那里把子品配菜选项**写死**
      // `unShow: false`），这道门读的是随单那份原始 `options[p].detail`。
      // 真出现「后端把必选组里所有选项都下发成 unShow」的数据，屏幕会画成可点、
      // 这道门却跳过。现在仓里没有给子品自身配菜选项写 `unShow` 的代码，举不出
      // 真实形状，所以只在这里记一笔；哪天要改，两半必须一起改。
      if (options.every(isOptionHidden)) return
      // 「至少要选几样」的唯一定义在 utils/sectionLimit 的 `sectionLowerBound`
      // （必选组恒 >= 1；四种 limitType 出自同一次 `sectionBounds` 计算）。
      // 「已经选了几样」的唯一定义在 utils/modOptionNumber 的 `calcSelectedTotal`
      // （`number > 0` 时按份数算，与置灰、数量步进同口径）。
      // 两个数都必须问这两个函数 —— 在这里自己解析 `minOption` / 自己数 `checked`
      // 就是让闸门与弹层哪天各说各话。
      const missing = sectionLowerBound(item) - calcSelectedTotal(options)
      if (missing > 0) num += missing
    })
    if (!modifications.length || !num) return ''
    // 这句话的唯一实现在 utils/sectionDesc 的 `comboRequiredCopy`（两个渲染文件共用）。
    // 以前这里是写死的英文模板串 `${num} selections required!`：不过语言包（法语 /
    // 中文门店的顾客看到一句英文）、而且是报错口气而不是「动词 + 结果」。
    // 数怎么来的仍然归上面那个循环管，本行只负责把它说成人话。
    return comboRequiredCopy(num)
  }

  /**
   * Edit Product
   * @param product {Object} Product information
   * @param comboRequiredIndex {Number} The subscript of the mandatory item of the combo product. This value is only available if the mandatory item of the combo product is clicked
   * @param chooseIndex {Number} The recently selected corresponding side dish option subscript
   */
  /**
   * 编辑商品
   * @param product {Object} 商品信息
   * @param comboRequiredIndex {Number} combo 商品的必选单品的下标，只有点击的是 combo 商品的必选单品，才会有此值
   * @param chooseIndex {Number} 最近选中的对应的配菜选项下标
   * @param firstIndex {Number}
   * @param comboRequiredProductIndex {Number} 必选子品在组内的下标（通行证的另一半）
   */
  editMutipleSize(product, comboRequiredIndex = null, chooseIndex = null, firstIndex = null, comboRequiredProductIndex = null) {
    this.clickItemId = product.id
    this.comboRequiredIndex = comboRequiredIndex
    this.comboRequiredProductIndex = comboRequiredProductIndex
    // The recently selected corresponding modification option subscript
    // 最近选中的对应的配菜选项下标
    if (typeof chooseIndex === 'number') this.secondIndex = chooseIndex
    if (typeof firstIndex === 'number') this.firstIndex = firstIndex
    // Is the combo product clicked?
    // 点击的是不是 combo 商品
    this.isChooseCombo = typeof comboRequiredIndex === 'number' || product.isCombo
    this.recommandIsEdit = true
    this.showChooseRecommandProductMutipleSizeDialog = true
    const currentRecommandProduct = this.recommandProductList.find(item => item.id === product.id)
    this.currentEditComboProduct = currentRecommandProduct ?? product.detail ?? product
  }

  choosedMutipleSize(id, product) {
    let pass = false
    if (product.id < 0 && product.isCombo) {
      const comboProduct = this.comboProductList.find(item => item.id === id)
      const modifications = !!comboProduct?.modifications.length
      pass = comboProduct?.selectSize?.name || comboProduct?.modifications.find(item => item.type === 'required' && item.options.find(option => option.checked)) || !!modifications
    } else {
      const recommandProduct = this.recommandProductList.find(item => item.id === id)
      pass = recommandProduct?.selectSize?.name || recommandProduct?.modifications.find(item => item.type === 'required' && item.options.find(option => option.checked))
    }
    return pass
  }

  /**
   * 被点的那个必选子品在组里的下标 —— 顾客选的东西要写回**这一格**。
   *
   * 只能按下标认，不能按 id 认：一个 `oneProduct` 组里「同一个子品要 2 份」是靠
   * **重复条目**承载的（见 STSGen2 的 comboGroup.count 语义），按 id 找会把第 2、
   * 第 3 条全算到第 1 条头上。
   *
   * 模板漏传下标时（`comboRequiredProductIndex` 是 null）回落到按 id 找 —— 比写死
   * 0 强，重复条目那种少数情况才会落错；正确接线由
   * `tests/unit/views/productDetailComboSubItemIndex.spec.js` 的接线钉守着。
   *
   * @param group {Object} 命中的 oneProduct 组
   * @param product {Object} 弹层交回来的子品
   * @return {Number} 该子品在组内 `options` / `products` 里的下标
   */
  _comboRequiredOptionIndex(group, product) {
    const options = group?.options ?? group?.products ?? []
    const productIndex = this.comboRequiredProductIndex
    if (
      typeof this.comboRequiredIndex === 'number' &&
      typeof productIndex === 'number' &&
      productIndex > -1 && productIndex < options.length
    ) return productIndex
    const byId = options.findIndex(option => option.id === product?.id)
    return byId > -1 ? byId : 0
  }

  /**
   * 这一格（`modifications[组].options[子品]`）对应的那条 `comboProductList` 记录。
   *
   * `comboProductList` 是 `_getEveryComboProduct` **一格一条 push** 出来的位置列表：
   * 同一个子品在一个 `oneProduct` 组里放两条（份数靠重复条目承载），列表里就有两条
   * 同 id 的记录。按 id 取时 `find` 永远返回第一条 —— 顾客给两格配的东西全算到第一条
   * 头上，而 `_addEachComboProductToCart` 的 override 支读的正是这个列表，
   * 所以**厨房收到的两行一模一样**。按位置取才对得上。
   *
   * 取不到键才回落到按 id 找。⚠️ **回落本身就是这条缺陷**（重复子品全算到第一条
   * 头上），所以它只是最后一道保险，不是常规路径 —— 上线之前建的购物车行两头都没有
   * 这个键，那些行不靠这个回落救，靠 `store/cartSchemaVersion.js` 在恢复
   * localStorage 那一刻整个作废掉（见那个文件的说明）。
   *
   * @param slot {Object} `product.modifications[组].options[子品]` 这一格
   * @param fallbackId {String|null} 格子上没 id 时的兜底（调用方一般给 `clickItemId`）
   * @return {Object|undefined} 这一格的那条记录
   */
  _comboProductForSlot(slot, fallbackId = null) {
    const list = this.comboProductList ?? []
    const key = slot?._comboSlot
    const bySlot = typeof key === 'string' ? list.find(item => item._comboSlot === key) : undefined
    if (bySlot) return bySlot
    return list.find(item => item.id === (slot?.id ?? fallbackId))
  }

  chooseRecommandMutipleSize({ selectSize, product, combo }) {
    let firstIndex = this.firstIndex
    let secondIndex = this.secondIndex
    // Is it a required product of the combo
    // 是不是套餐的必选商品
    //
    // ⚠️ `comboRequiredIndex` 已经指明是**哪一组**了，就别再按 id 找回去：两个
    // `oneProduct` 组共用同一个子品（Item 1 = [Salad, Fries]、Item 2 = [Wings, Salad]）时，
    // 按 id 找永远返回第一组，而组内下标用的是顾客真正点的那一组的 —— 于是选择被写进
    // **另一个商品**（Fries 带着 Salad 的配菜进 POS），顾客点的那一格一个字都没写。
    // 闸门现在只认内容，那一格于是永远红、再点还是同样写错：套餐永远加不进购物车。
    const isRequiredCombo = (typeof this.comboRequiredIndex === 'number'
      ? this.requiredComboList[this.comboRequiredIndex]
      : undefined) ??
      this.requiredComboList.find(item => item.options.findIndex(option => option.id === product.id) > -1)

    if (this.isChooseCombo) {
      if (typeof this.comboRequiredIndex === 'number' && isRequiredCombo) {
        // 组在 `product.modifications` 里的下标：按**同一个 options 数组**认。
        // `_getRequiredComboList` 造的是新对象，但 `options` 是 `{ ...item }` 浅拷贝出来的
        // 同一个数组引用，所以这是唯一不会认错的判据 —— 按 (id, name) 找会在两个同名
        // oneProduct 组之间选错（`_getComboProductList` 给所有 oneProduct 组的 id 都是 `''`）。
        const byOptions = this.product.modifications.findIndex(item => item.options === isRequiredCombo.options)
        if (byOptions > -1) {
          firstIndex = byOptions
        } else if (isRequiredCombo.id === '' || isRequiredCombo.id === '-1') {
          firstIndex = this.product.modifications.findIndex(
            item => item.id === isRequiredCombo.id && item.name === isRequiredCombo.name
          )
        } else {
          firstIndex = this.comboRequiredIndex
        }
        // 写回**被点的那一格**，不是这一组的第 0 格（见 `_comboRequiredOptionIndex`）。
        secondIndex = this._comboRequiredOptionIndex(isRequiredCombo, product)
      }
      if (typeof firstIndex === 'undefined') firstIndex = 0
      const option = this.product.modifications[firstIndex].options[secondIndex]
      // Find the corresponding combo product and assign a value
      // 找到对应的 combo 商品并赋值 —— 按**这一格**取，不是按 id 取（见 `_comboProductForSlot`）
      const comboProduct = this._comboProductForSlot(option, this.clickItemId)
      // 顾客选的东西**先无条件写进这一格自己**。以前这两句躲在下面那个 if 里：
      // 记录一条都找不到时顾客点了等于没点 —— 闸门读的就是 `options[].detail`，
      // 于是那一格永远红、点多少次都清不掉，套餐加不进购物车。写在这里还顺手让那种
      // 退化情况**厨房也是对的**：`_addEachComboProductToCart` 拿不到记录时用的
      // 正是 `each.detail`。
      //
      // ⚠️ 这三个取值**刻意都不加可选链**。`option` / `option.detail` / `product`
      // 任何一个取不到都是接线错了，当场抛比静默跳过强得多 —— 静默跳过的净效果是
      // 「记录写了、格子没写」，而闸门读的是格子，于是那一格恒红，症状离原因十万八千里。
      // 先读 `product.modifications` 也是为了不在 `product` 缺席时**先把这一格清成 `[]`
      // 再抛**（半截写入比整句不写更难查）。
      option.detail.modifications = product.modifications ?? []
      option.detail.selectSize = selectSize
      if (typeof comboProduct !== 'undefined') {
        comboProduct.modifications = product.modifications
        comboProduct.selectSize = selectSize
      }
    } else {
      const recommandProduct = this.recommandProductList.find(item => item.id === this.clickItemId)
      recommandProduct.selectSize = selectSize
      recommandProduct.modifications = product.modifications
      recommandProduct.comboProducts = product?.comboProducts ?? []
      if (product?.comboProductList?.length) recommandProduct.comboProductList = product.comboProductList
    }

    if (isRequiredCombo) {
      // 屏幕上那份列表也要写到**同一格**：`products` 与 `options` 是 1:1 map 出来的，
      // 所以下标通用。按 id 找会把同组的重复条目（份数靠重复条目承载）全算到第一条头上，
      // 于是屏上显示的配菜与随单发出的是两条。
      const optionIndex = this._comboRequiredOptionIndex(isRequiredCombo, product)
      const requireComboProduct = (isRequiredCombo.products ?? [])[optionIndex] ??
        (isRequiredCombo.products ?? []).find(item => item.id === product.id)
      if (requireComboProduct?.detail) {
        requireComboProduct.detail.modifications = product?.modifications ?? []
        requireComboProduct.detail.selectSize = selectSize
      }
    }

    if (combo !== true) {
      const option = this.product.modifications[firstIndex].options[secondIndex]
      option.checked = true
      if ((selectSize.price || selectSize.price === 0) && !option.isCombo) option.adjustPrice = selectSize.price
    }
    this.showChooseRecommandProductMutipleSizeDialog = false
    if (combo !== true) this.getCheckNum(this.firstIndex, this.secondIndex)
  }

  /**
   * Functions executed after the option is changed
   * value: Variables bound by the box
   * eachModification: Corresponding modifications
   * eachOption: Corresponding modification option
   * modificationsIndex: Corresponding modification subscript
   * optionsIndex: The corresponding modification option subscript
   */
  /**
   * 选项发生改变后，执行的函数
   * value: 选框绑定的变量
   * eachModification: 对应的配菜
   * eachOption: 对应的配菜选项
   * modificationsIndex: 对应的配菜下标
   * optionsIndex: 对应的配菜选项下标
   */
  handleCheckBoxChoose(value, eachModification, eachOption, modificationsIndex, optionsIndex) {
    if (eachModification.id < 0) {
      // The recently selected recommendation ID is used to obtain recommendation data and display relevant information on the page
      // 最近选中的推荐菜 id，用来获取推荐菜数据，在页面中展示相关信息
      this.clickItemId = eachOption.id
      // The recently selected corresponding modification subscript
      // 最近选中的对应的配菜下标
      this.firstIndex = modificationsIndex
      // The recently selected corresponding modification option subscript
      // 最近选中的对应的配菜选项下标
      this.secondIndex = optionsIndex
      this.isChooseCombo = eachModification.isCombo ?? false
      this.currentEditComboProduct = null
    }
    // If the modification pop-up window is displayed, the code will stop running (that is, click the edit button)
    // 若显示配菜弹窗，将停止代码运行（也就是点击 edit 按钮的情况）
    if (this.showChooseRecommandProductMutipleSizeDialog) return
    // When single selection is selected, if you click this option again, code running will be stopped
    // 单选选中时，若再次点击此选项，将停止代码运行
    if ((Number(eachModification.minOption) === 1 && eachModification.limitType !== 'range') && eachModification.type === 'required') {
      const checkedOptionIndex = eachModification.options.findIndex(item => item.checked)
      if (checkedOptionIndex === optionsIndex) return
    }

    if (eachModification.id < 0) {
      const choosedRecommandProductInfo = this.recommandProductList.find(eachModification => eachModification.id === eachOption.id)
      // 有配菜组就一定要先弹定制层 —— 判据不看勾选状态，
      // 否则商家把每个组都配了默认勾选的推荐菜会被判成"不用选"，
      // 顾客点一下就加购，配菜的加价静默进了实付金额。
      // Never look at the tick state here, see utils/recommendCustomise.
      const isCombo = choosedRecommandProductInfo.type === 'combo'
      if (value && (recommendNeedsCustomise(choosedRecommandProductInfo) || isCombo)) {
        eachOption.checked = false
        this.showChooseRecommandProductMutipleSizeDialog = true
      } else {
        eachOption.checked = !eachOption.checked
        // Clear the modifications after unchecking
        // 取消勾选后，清空配菜选择
        // if (!eachOption.checked) {
        //   choosedRecommandProductInfo.modifications.forEach(modification => {
        //     if (!modification.options) return
        //     modification.options.forEach(option => {
        //       option.checked = false
        //     })
        //   })
        // }
      }
    } else {
      eachOption.checked = !eachOption.checked
      this._clearClickItemInfo()
    }
  }

  _clearClickItemInfo() {
    this.clickItemId = null
    this.isChooseCombo = null
    this.firstIndex = null
    this.secondIndex = null
  }

  /**
   * Price display of recommendations
   * @param {String} recommandProductId Commodity ID
   */
  /**
   * 推荐菜价格显示
   * @param {String} recommandProductId 商品 id
   */
  getRecommandProductPrice(recommandProductId) {
    // Reference currentCurrency to make this method reactive to currency changes
    // 引用 currentCurrency 使此方法在货币切换时响应式更新
    const _currency = this.currentCurrency // eslint-disable-line no-unused-vars
    const symbol = getCurrencySymbol()
    const position = getSymbolPosition()
    const recommandProduct = this.recommandProductList.find(item => item.id === recommandProductId)
    if (!recommandProduct) return ''
    if (recommandProduct?.sizeSettings?.mutipleSize) {
      if (recommandProduct.selectSize) {
        const rawPrice = recommandProduct?.selectSize?.price
        const price = formatDecimalNumber(convertPrice(parseFloat(rawPrice) || 0))
        if (position === 'after') {
          return recommandProduct?.selectSize?.name + ' - ' + price + ' ' + symbol
        }
        return recommandProduct?.selectSize?.name + ' - ' + symbol + price
      } else {
        const settings = recommandProduct?.sizeSettings?.settings || []
        if (settings.length === 0) return ''
        const ls = settings.map(item => convertPrice(parseFloat(item.price) || 0))
        const minPrice = formatDecimalNumber(Math.min(...ls))
        const maxPrice = formatDecimalNumber(Math.max(...ls))
        if (ls.length === 1) {
          if (position === 'after') {
            return `${minPrice} ${symbol}`
          }
          return `${symbol}${minPrice}`
        }
        if (position === 'after') {
          return `${minPrice} ${symbol} - ${maxPrice} ${symbol}`
        }
        return `${symbol}${minPrice} - ${symbol}${maxPrice}`
      }
    } else {
      const rawPrice = recommandProduct?.price
      const price = formatDecimalNumber(convertPrice(parseFloat(rawPrice) || 0))
      if (position === 'after') {
        return price + ' ' + symbol
      }
      return symbol + price
    }
  }

  /**
   * Calculation of recommendation modification for ordinary products
   * @param product {Object} Product information
   * @return {Number} Total price of recommended dishes for ordinary commodities
   */
  /**
   * 计算普通商品推荐菜配菜
   * @param product {Object} 商品信息
   * @return {Number} 普通商品推荐菜配菜的总价格
   */
  recommendedDishesForGeneralCommodities(product) {
    let adjustMoney = 0
    const recommandProduct = this.recommandProductList.find(ls => ls.id === product.id)
    const recommandProductModifications = recommandProduct?.modifications ?? []
    let recommendationMoney = 0

    if (recommandProductModifications.length > 0) {
      recommandProductModifications.forEach(recommandProductItem => {
        recommandProductItem.options.forEach(recommandProductEach => {
          if (recommandProductEach.checked) {
            recommendationMoney += parseFloat(recommandProductEach.adjustPrice ?? 0) * (recommandProductEach.number || 1)

            if (recommandProductEach.detail && recommandProductEach.detail?.modifications?.length) {
              recommandProductEach.detail.modifications.forEach(modification => {
                modification.options.forEach(option => {
                  if (option.checked) recommendationMoney += parseFloat(option.adjustPrice ?? 0) * (option.number || 1)
                })
              })
            }
          }
        })
      })
    }
    adjustMoney = adjustMoney + parseFloat(recommendationMoney)
    return adjustMoney
  }

  /**
   * Get product price copy
   * @param data {Object} Product information
   * @return {String} Size of side dishes
   * For example: size name - size amount
   */
  /**
   * 获得商品价格文案
   * @param data {Object} 商品信息
   * @return {String} 配菜的 size
   * 例如：size 名字 - size 金额
   */
  getRequiredProductPrice(data) {
    // Reference currentCurrency to make this method reactive to currency changes
    // 引用 currentCurrency 使此方法在货币切换时响应式更新
    const _currency = this.currentCurrency // eslint-disable-line no-unused-vars
    const name = data?.detail?.selectSize?.name
    const price = data?.detail?.selectSize?.price
    if (name === null || price === null || data?.detail?.selectSize === undefined) return
    const symbol = getCurrencySymbol()
    const position = getSymbolPosition()
    const formattedPrice = formatDecimalNumber(convertPrice(parseFloat(price) || 0))
    if (position === 'after') {
      return name + ' - ' + formattedPrice + ' ' + symbol
    }
    return name + ' - ' + symbol + formattedPrice
  }

  /**
   * Get product pictures
   * @param {String} Commodity ID
   * @returns {String} Product picture
   */
  /**
   * 获取商品图片
   * @param {String} 商品 id
   * @returns {String} 商品图片
   */
  getRecommandProductSrc(id) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    const product = this.recommandProductList.find(item => item.id === id)
    return product ? (getLocalizedField(product, 'image') || product.image) : ''
  }

  /**
   * Get product name
   * @param {String} Commodity ID
   * @returns {String} Trade name
   */
  /**
   * 获取商品名称
   * @param {String} 商品 id
   * @returns {String} 商品名称
   */
  getRecommandProductName(id) {
    return this.recommandProductList.find(item => item.id === id)?.name
  }

  getLocalizedRecommandProductName(id) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    const product = this.recommandProductList.find(item => item.id === id)
    return product ? (getLocalizedField(product, 'name') || product.name) : ''
  }

  /**
   * Get pictures of combo products
   * @param {String} Commodity ID
   * @returns {String} Package product picture
   */
  /**
   * 获取套餐商品图片
   * @param {String} 商品 id
   * @returns {String} 套餐商品图片
   */
  getComboProductSrc(id) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    const product = this.comboProductList?.find(item => item.id === id)
    return product ? (getLocalizedField(product, 'image') || product.image) : ''
  }

  /**
   * Get combo product name
   * @param {String} Commodity ID
   * @returns {String} Package product name
   */
  /**
   * 获取套餐商品名称
   * @param {String} 商品 id
   * @returns {String} 套餐商品名称
   */
  getComboProductName(id) {
    return this.comboProductList.find(item => item.id === id)?.name
  }

  getLocalizedComboProductName(id) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    const product = this.comboProductList.find(item => item.id === id)
    return product ? (getLocalizedField(product, 'name') || product.name) : ''
  }

  choosedItem(item) {
    this.choosedItemInfo = item
  }

  /**
   * Display the edit icon of combo required items
   * @param comboProduct {Object} Information of combo required items
   * @return {Boolean} Whether to display
   */
  /**
   * 显示 combo 必选单品的 edit 图标
   * @param comboProduct {Object} combo 必选单品的信息
   * @return {Boolean} 是否显示
   */
  showComboRequiredEditIcon(comboProduct) {
    const detail = comboProduct.detail ?? {}
    return detail?.sizeSettings?.mutipleSize || detail?.modifications?.length
  }

  _addDisabledJumpButton() {
    const self = this
    window.addEventListener('message', function(e) {
      if (e.data.name === 'isIframe') {
        self.disabledButton = true
      }
    })
  }

  _sendMsgToBacken() {
    // Iframe sends data to the father to inform the caller that the page has been loaded
    // iframe 发送数据给父亲, 方便告诉调用者，页面已加载完毕
    window.top.postMessage({
      name: 'mounted',
      data: 'mounted',
    }, '*')
  }

  // Get the required modification subscript to facilitate the form verification and judgment
  // 获取必选的配菜下标，方便表单验证判断
  _getProductRequiredModificationsIndex() {
    this.product.modifications.forEach((item, index) => {
      if (item.type === 'required') {
        this.requiredIndexList.push(index)
      }
    })
  }

  getProductPrice(price) {
    const productId = this.$route.query.productId
    if (productId !== undefined) {
      return this.product.singlePrice
    } else {
      return price
    }
  }

  // Whether to display Collapse
  // 是否显示 Collapse
  shwoCollapse(list) {
    return list.find(item => !item.unShow)
  }

  // Each click
  // 每次点击
  getCheckNum(index, chooseIndex) {
    this.product.modifications.forEach((e, i, a) => {
      if (i === index) {
        // `limitType` 归一化成 range / limit / exactly 三选一（见 utils/sectionLimit 的
        // `sectionLimitKind`）：**认不出来的值一律当 `exactly`**（owner 2026-08-10 裁定）。
        // 以前这条链直接比裸 `limitType`，没有 `else` —— 没写 limitType 的必选组
        // 一条校验都不跑，一样都不选照样加进购物车，屏幕上却写着「Required」。
        const limitKind = sectionLimitKind(e)
        const minOption = e.minOption
        const chooseList = []
        const list = []
        // 这组一次最多能选几样：唯一定义在 utils/sectionLimit.js
        // （「恰好选 N 样」的组把上限写在 minOption 上；null = 没配上限）。
        // 以前这里自己写了一遍那条回退，三个文件各一份，预勾选那条路没写 —— 就是这批的洞。
        const sectionLimit = sectionMaxOption(e)
        // Filter out the selected and unselected, and add them to different arrays
        // 筛选出已选和未选的选项，分别添加到不同的数组
        e.options.forEach((each, Index, array) => {
          list.push(Index)
          if (each.checked) {
            chooseList.push(Index)
            each.disabled = false
            // 初始化 number 字段
            if (!each.number || each.number <= 0) {
              each.number = 1
            }
            const noChooseIndexList = list.filter(function(v) { return chooseList.indexOf(v) === -1 })
            noChooseIndexList.forEach((eleIndex) => {
              e.options[eleIndex].disabled = false
            })
          }
        })

        // 使用 calcSelectedTotal 计算选中的总数量（考虑 number 字段）
        let selectedNum = calcSelectedTotal(e.options)

        // For single choice control, you can click to switch and select other options to obtain the selected quantity
        // 单选的控制，可以点击切换选中其他选项，获取已选择的数量
        if (sectionIsSingleSelect(e) && e.type === 'required') {
          const noChooseIndexList = list.filter(item => item !== chooseIndex)
          // When the RecommandProductMutipleSizeContent pop-up window appears, do not select
          // 出现 RecommandProductMutipleSizeContent 弹窗时，不进行选中操作
          if (!this.showChooseRecommandProductMutipleSizeDialog) {
            e.options[chooseIndex].checked = true
            e.options[chooseIndex].number = 1
            noChooseIndexList.forEach((eleIndex) => {
              e.options[eleIndex].checked = false
              e.options[eleIndex].number = 0
            })
          } else {
            e.options[chooseIndex].checked = false
            e.options[chooseIndex].number = 0
          }
          selectedNum = calcSelectedTotal(e.options)
          // console.log(noChooseIndexList, selectedNum)
        } else if (sectionIsSingleSelect(e)) {
          // 可选的单选组：一次只留一个，点另一个直接换选，其余选项不灰。
          // 灰掉的话商家配了默认勾选时顾客一打开就发现别的口味全点不动，
          // 得先取消预勾的那个才能选 —— 和"售罄"在屏幕上还长得一样。
          // An optional single-pick section: swapping is one tap, nothing greys out.
          applySingleSelectExclusive(e, chooseIndex)
          selectedNum = calcSelectedTotal(e.options)
        } else {
          // Disable other options when multiple selections reach the maximum value required by the selection
          // 多选到达选中要求的最大值时，禁用其他选项（没配上限就一个都不灰）
          if (sectionLimit !== null && selectedNum >= sectionLimit) {
            const noChooseIndexList = list.filter(function(v) { return chooseList.indexOf(v) === -1 })
            noChooseIndexList.forEach((eleIndex) => {
              e.options[eleIndex].disabled = true
            })
          } else {
            const noChooseIndexList = list.filter(function(v) { return chooseList.indexOf(v) === -1 })
            noChooseIndexList.forEach((eleIndex) => {
              e.options[eleIndex].disabled = false
            })
          }
        }

        // The following are error message codes
        // 以下是关于错误信息代码
        if (e.type === 'required') {
          if (limitKind === 'exactly') {
            // 「恰好选 N 样」的 N 就是这一组的有效上限（见 utils/sectionLimit.js：
            // min 为主、其次 max、必选组都说不出就兜底 1）。这一支在
            // `e.type === 'required'` 里，所以 sectionLimit 一定是个正整数
            // （可选的 exactly 组是 NO_CAP，但可选组不走校验）。校验侧必须问同一个函数 ——
            // 以前这里读裸 `parseInt(minOption)`，两个键都没写出数的组就拿 NaN 去比，
            // NaN 与任何数都不相等，于是这一组永远判红、商品永远加不进购物车。
            if (selectedNum !== sectionLimit) {
              this.wrongMsg = `Type：exactly ${e.name}'s number must be ${sectionLimit}`
              // If you want to change from checking the correctness after clicking the selection box, comment on the following code
              // 如果想换成不是点击选择框后就验证正确性，就注释下行代码
              e.wrong = tParams('select_n_required', 'Select {n} (Required)', { n: sectionLimit })
              this.pass = false
              const i = this.passList.indexOf(index)
              // If not, remove the data from passList
              // 若不通过，将该条数据从 passList 中移除
              if (i !== -1) {
                this.passList.splice(i, 1)
              }
            } else {
              this.pass = true
              e.wrong = false
              if (this.passList.indexOf(index) === -1 && !this.showChooseRecommandProductMutipleSizeDialog) {
                this.passList.push(index)
              }
            }
          } else if (limitKind === 'range') {
            // 下限走契约（utils/sectionLimit 的 sectionLowerBound）—— 红字念的那个数
            // 和这里拦人的这个数是同一个函数算出来的，不是两处各写一遍 `parseInt`
            // 碰巧一致。这一支在 `e.type === 'required'` 里，所以拿到的**一定**是个
            // >= 1 的整数：必选组的地板是 1，后台没配 `minOption` 也一样
            // （owner 2026-08-10：「必选组不存在连 1 个都不选就能过去的」）。
            // 以前这里读的是裸 `lowerBound`，说不出数就 `minNum !== null` 整条短路 ——
            // 勾一下再取消，这组就带着 0 个选择进了 passList，加购时不再判红。
            const minNum = sectionLowerBound(e)
            if (parseInt(selectedNum) < minNum) {
              this.wrongMsg = `Type：range ${e.name}'s MinOption is ${minOption}`
              this.pass = false
              // 念的两个数各自要「念得出」才念（见 utils/sectionDesc 的 rangeCopy）：
              // 原值直出会念成 `Select between 2 and 0` / `Select between 2.5 and 3`，
              // 而校验卡的是 parseInt 之后的下限、置灰卡的是有效上限。
              e.wrong = rangeWrongCopy(e)

              const i = this.passList.indexOf(index)
              if (i !== -1) {
                this.passList.splice(i, 1)
              }
            } else {
              this.pass = true
              e.wrong = false
              if (this.passList.indexOf(index) === -1 && !this.showChooseRecommandProductMutipleSizeDialog) {
                this.passList.push(index)
              }
            }
          } else if (limitKind === 'limit') {
            if (parseInt(selectedNum) < 1) {
              this.pass = false
              // 这一支拦的是「一样都没选」（就是上一行那个 < 1），所以念「至少选 1 样」。
              // 以前念的是 `Select up to {minOption}`，而 `limit` 组的 minOption 通常是
              // 0 或空 —— 屏上成了「最多选择 0 项（必选）」/ `Select up to  (Required)`。
              e.wrong = limitWrongCopy()
              const i = this.passList.indexOf(index)
              if (i !== -1) {
                this.passList.splice(i, 1)
              }
            } else {
              this.pass = true
              e.wrong = false
              if (this.passList.indexOf(index) === -1 && !this.showChooseRecommandProductMutipleSizeDialog) {
                this.passList.push(index)
              }
            }
          }
        }
      }
    })
  }

  getDesc(item) {
    // Reference currentLanguage to ensure Vue reactivity on language change
    // 引用 currentLanguage 以确保语言切换时 Vue 的响应式更新
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    // 推荐菜那种「一个商品一个伪组」的条目：能选的就是列出来的那几样，不走配菜组上限
    if (item.id < 0 && !item.isCombo) return tParams('select_up_to_n', 'Select up to {n}', { n: item.options.length })
    // 「这一组要选几样」这句话里的数字，与换选 / 置灰 / 数量步进 / 单选渲染 /
    // 预勾选截断问的是同一个问题，所以三处 getDesc 共用 sectionPickDesc（见 utils/sectionDesc）。
    // 别在这里退回裸 maxOption，也别就地补一个回退三元式 —— 那就是分叉的来源。
    const firstName = sectionPickDesc(item, this.modificationDescSettings?.rangeDesc)
    // 可选组不带任何「必选」标记：念得出就念，念不出就一个字都不念。
    if (item.type !== 'required') return firstName
    // 必选组：「必选」这个信息**一定要说出去**，顾客不知道这组必填，
    // 比看到一个难看的括号严重得多（owner 2026-08-10 裁定，两仓统一）。
    // 但没有句子可挂的时候，一个前面带空格的「 (Required)」就是个残句 ——
    // 组名底下挂一对括号，既没说要选几样，也不像是句话。
    // 所以：没句子就**单独念那个词本身**，不带括号、不带前导空格。
    // 走到这里的只有「必选 limit 组没配上限」和没写 limitType 的组 ——
    // `range` 与必选的 `exactly` 组永远念得出数（见 utils/sectionDesc）。
    if (!firstName) return t('required', 'Required')
    // 有句子时后缀整句从语言包取，**不在代码里拼括号**：中文包的 `*_required`
    // 那几句用的是全角（必选）、无空格，而代码拼出来的是半角空格 + 半角括号 ——
    // 同一个必选组的组头与红字于是念两种标点（英文/法文对得上，只有中文不对）。
    // 空格也在语言包里：它是句子的一部分，不是排版。
    return firstName + t('required_suffix', ' (Required)')
  }

  /**
   * 判断是否是单选模式
   * @param {Object} mod - 配菜组
   * @returns {Boolean}
   */
  isRadioSelect(mod) {
    return isRadioSelectFn(mod)
  }

  /**
   * 获取选项的显示数量
   * @param {Object} option - 选项
   * @returns {Number|String}
   */
  getOptionDisplayNumber(option) {
    return getOptionDisplayNumberFn(option)
  }

  /**
   * 判断选项是否可以增加数量
   * @param {Object} option - 选项
   * @param {Object} mod - 配菜组
   * @returns {Boolean}
   */
  canIncrease(option, mod) {
    return canIncreaseOption(option, mod)
  }

  /**
   * 处理选项点击事件
   * @param {Number} modIndex - 配菜组索引
   * @param {Number} optionIndex - 选项索引
   * @param {Object} mod - 配菜组
   * @param {Object} option - 选项
   */
  /**
   * 多选配菜的 @input 处理（非单选组的 van-checkbox，见 isSinglePickSection）
   * Handler for multi-select checkbox @input event.
   */
  handleMultiCheckBoxInput(value, eachModification, eachOption, modificationsIndex, optionsIndex) {
    // 标记当前事件周期中有 @input 触发
    // Mark that @input was triggered in this event cycle
    this._inputFiredForOption = `${modificationsIndex}_${optionsIndex}`

    // 复用原有的 handleCheckBoxChoose 逻辑（处理推荐菜、普通配菜等）
    // Reuse existing handleCheckBoxChoose logic
    this.handleCheckBoxChoose(value, eachModification, eachOption, modificationsIndex, optionsIndex)

    // 如果刚被勾选，初始化 number 为 1
    if (eachOption.checked && (!eachOption.number || eachOption.number <= 0)) {
      eachOption.number = 1
    }
    // 如果取消勾选，重置 number 为 0
    if (!eachOption.checked) {
      eachOption.number = 0
    }

    // 调用验证逻辑（原先由 handleOptionClick 中调用）
    // Run validation logic (previously called from handleOptionClick)
    this.getCheckNum(modificationsIndex, optionsIndex)
  }

  handleOptionClick(modIndex, optionIndex, mod, option) {
    // van-checkbox 事件顺序：@input (handleMultiCheckBoxInput) 先于 @click 触发。
    // @input 已经处理了勾选/取消勾选和 number 初始化。
    // @click 只需要处理"已选中状态下再次点击增加数量"的场景。
    //
    // Event order: @input fires before @click.
    // @input already handles check/uncheck and number init.
    // @click only handles "re-click on checked option to increase number".

    // 如果 @input 刚在本事件周期中处理了这个选项，跳过
    if (this._inputFiredForOption === `${modIndex}_${optionIndex}`) {
      this._inputFiredForOption = null
      return
    }

    // 仅处理：已选中 + 非单选 = 增加数量
    if (option.checked && !isRadioSelectFn(mod)) {
      if (canIncreaseOption(option, mod)) {
        this.increaseNumber(modIndex, optionIndex, mod, option)
      }
    }
  }

  /**
   * 增加选项数量
   * @param {Number} modIndex - 配菜组索引
   * @param {Number} optionIndex - 选项索引
   * @param {Object} mod - 配菜组
   * @param {Object} option - 选项
   */
  increaseNumber(modIndex, optionIndex, mod, option) {
    if (increaseOptionNumber(option, mod)) {
      this.validateAndUpdateMod(modIndex, mod)
      this.$forceUpdate()
    }
  }

  /**
   * 减少选项数量
   * @param {Number} modIndex - 配菜组索引
   * @param {Number} optionIndex - 选项索引
   * @param {Object} mod - 配菜组
   * @param {Object} option - 选项
   */
  decreaseNumber(modIndex, optionIndex, mod, option) {
    if (decreaseOptionNumber(option, mod)) {
      this.validateAndUpdateMod(modIndex, mod)
      this.$forceUpdate()
    }
  }

  /**
   * 验证并更新配菜组状态
   * @param {Number} modIndex - 配菜组索引
   * @param {Object} mod - 配菜组
   */
  validateAndUpdateMod(modIndex, mod) {
    const selectedTotal = calcSelectedTotal(mod.options)
    // `limitType` 归一化成 range / limit / exactly 三选一（见 utils/sectionLimit 的
    // `sectionLimitKind`）：**认不出来的值一律当 `exactly`**（owner 2026-08-10 裁定）。
    // 以前这条链直接比裸 `limitType`，没有 `else` —— 没写 limitType 的必选组
    // 一条校验都不跑，一样都不选照样加进购物车，屏幕上却写着「Required」。
    const limitKind = sectionLimitKind(mod)
    // 有效上限，唯一定义见 utils/sectionLimit.js（null = 没配上限）
    const sectionLimit = sectionMaxOption(mod)

    // 更新 disabled 状态
    if (sectionLimit !== null && selectedTotal >= sectionLimit) {
      mod.options.forEach((opt, idx) => {
        if (!opt.checked) {
          opt.disabled = true
        }
      })
    } else {
      mod.options.forEach((opt, idx) => {
        if (!opt.checked) {
          opt.disabled = false
        }
      })
    }

    // 验证状态
    if (mod.type === 'required') {
      if (limitKind === 'exactly') {
        // 有效上限就是「恰好选几样」的那个数。这一支在 `mod.type === 'required'` 里，
        // 而**必选**的 `exactly` 组永远给得出一个正整数（两个键都空就兜底 1，
        // 见 utils/sectionLimit.js），所以这里没有第二个来源可回落。
        // （可选的 `exactly` 组会是 NO_CAP，但它根本走不到这一支 —— 可选组不校验。）
        const targetCount = sectionLimit
        if (selectedTotal !== targetCount) {
          // 与另外两条红字路（点击后 / 加购整单校验）念同一句：以前这里是写死英文的
          // 模板串，法语/中文门店的组头念中文、步进这一步却念英文。数字取的是有效上限
          // （`sectionLimit` 就是上一行 `targetCount` 的来源），不是裸字段。
          mod.wrong = tParams('select_n_required', 'Select {n} (Required)', { n: sectionLimit })
          const i = this.passList.indexOf(modIndex)
          if (i !== -1) {
            this.passList.splice(i, 1)
          }
        } else {
          mod.wrong = false
          if (this.passList.indexOf(modIndex) === -1) {
            this.passList.push(modIndex)
          }
        }
      } else if (limitKind === 'range') {
        // 下限走契约（utils/sectionLimit 的 sectionLowerBound），与另外五道闸门同源。
        // 这一支在 `mod.type === 'required'` 里，所以下限**一定** >= 1（地板见契约）——
        // 以前读裸 `lowerBound`，说不出数时左半边整条短路，步进到 0 也照样放行。
        const minNum = sectionLowerBound(mod)
        if (selectedTotal < minNum || (sectionLimit !== null && selectedTotal > sectionLimit)) {
          // 与另外两条红字路走同一句实现（rangeCopy）：原值直出会念成
          // `Select between 2 and 0`，而且这句以前是写死英文、门店换语言也不变
          mod.wrong = rangeWrongCopy(mod)
          const i = this.passList.indexOf(modIndex)
          if (i !== -1) {
            this.passList.splice(i, 1)
          }
        } else {
          mod.wrong = false
          if (this.passList.indexOf(modIndex) === -1) {
            this.passList.push(modIndex)
          }
        }
      } else if (limitKind === 'limit') {
        if (selectedTotal < 1) {
          // 拦的是「一样都没选」，念「至少选 1 样」；以前念的 `Select up to {maxOption}`
          // 在 maxOption 没写时是 `Select up to  (Required)`，而且写死英文
          mod.wrong = limitWrongCopy()
          const i = this.passList.indexOf(modIndex)
          if (i !== -1) {
            this.passList.splice(i, 1)
          }
        } else {
          mod.wrong = false
          if (this.passList.indexOf(modIndex) === -1) {
            this.passList.push(modIndex)
          }
        }
      }
    }
  }

  // Initialize passList to ensure that the previous form validation is completed
  // 初始化 passList 来保证之前的表单验证都完成了
  initPassList() {
    this.product.modifications.forEach((item, index) => {
      if (item.type === 'required') {
        this.passList.push(index)
      }
    })
  }

  // Get the product object pointed to by the cancellation object and cancel the check of the recommandProduct
  // 获取取消对象指向的 product 对象，并将 recommandProduct 取消 check
  _getEditProduct(product) {
    const data = {
      ...product,
      modifications: product.modifications.map(item => {
        // 改单：顾客上次选过东西的组摆开给他看（fromCart）。
        // Cart-line refill: reopen the sections the customer picked in.
        const collapse = resolveEditCollapse(item, { fromCart: true })

        if (!(item.id < 0) || (item.id < 0 && item.isCombo)) {
          return {
            ...item,
            collapse
          }
        } else {
          return {
            ...item,
            collapse,
            options: item.options.map(each => {
              return {
                ...each,
                checked: false,
                number: each.number || 0,
              }
            })
          }
        }
      })
    }
    data.price = product.price
    // The unit price of food returns to the original price
    // 食品单价回归到原始价格
    product.modifications.forEach(item => {
      item.options.forEach(option => {
        if (option.checked === true) data.price -= Number(option.adjustPrice)
      })
    })
    const upgradeProductsPrice = data?.upgradeProducts?.items?.find(item => item.checked)?.price ?? 0
    data.price -= upgradeProductsPrice

    return JSON.parse(JSON.stringify(data))
  }

  /**
   * 读商品（get-product）。多版本菜单 B6：带这家店此刻的菜单（缓存键随之含 menuId）；菜单已不在用 ⇒ 静默重新解析一次再读（不弹窗、不循环）。
   * 读不到 ⇒ undefined，交给 getData 停住。重新解析之后仍「菜单不在用」⇒ 给一句白话提示（U-B6-2；以前停在空白页什么都不说）；
   * 别的读失败照今天（拦截器已经弹过提示，不弹第二次）。
   * @param {Object} requestData get-product 的请求体（不含 menuId）
   */
  async _loadProduct(requestData) {
    const routeVenueId = safeDecodeURI(this.$route.params.venueId)
    const readProduct = () => getProduct(withMenuId(requestData, menuIdFor(this.$store.state, routeVenueId)))
    const res = await readWithMenuRetry(readProduct, () => reresolveMenu(this.$store, {
      venueId: routeVenueId,
      query: this.$route.query,
      table: this.number,
      route: this.$route
    })).catch(error => {
      console.log(error)
      if (isMenuGoneError(error)) createMessageDialog(productReadFailedText())
      this.$store.commit('closeLoading')
    })
    return res
  }

  async getData() {
    // Judge whether it is an edit product
    // 判断是否是编辑商品
    const productId = this.$route.query.productId
    // If it is edit product
    // 如果是 edit product
    if (productId !== undefined) {
      this.product = this._getEditProduct(this.proList[productId])
      // 改单也要重算一次"还能不能再选" —— 顾客原来的选择是整批摆回屏幕上的，
      // 那一刻还没算过哪些项点不动（也顺手清掉早期版本存进购物车的灰态）。
      // Cart-line refill puts every earlier pick back at once; recompute here too.
      this._applyDefaultSelectionLimits()
      this._getChoosedRecommandProductMutipleSizeInfo()
      this.initPassList()
      // 改单不再逐个子品发通行证：闸门现在问的是「这一格自己选够了没有」，
      // 而顾客上一次的选择就存在 `modifications[组].options[子品].detail` 里，
      // 随购物车一起回来 —— 内容自己会说话，不需要一张票替它说。
      if (this.isCombo) this._getRequiredComboList()
      this.$store.commit('closeLoading')
    } else {
      const requestData = {
        id: this.productId
      }
      const deliveryInfo = this.$store?.state?.contactDetails?.deliveryInfo[this.venueId] ?? {}
      // If it is a delivery system and a reservation order, the reservation date will be transferred to the interface
      // 若是外卖系统，并且是预定单，将预定日期传给接口
      if (this.isOnline && deliveryInfo.preOrderTimeSettings) requestData.preOrderDate = dayjs(deliveryInfo.preOrderTimeSettings).format('YYYY-MM-DD')

      // add product
      let res = await this._loadProduct(requestData)
      // 读失败（含重新解析之后仍不在用）：停在这里，不再对 undefined 取属性抛错（以前别的读失败也会在下一行抛）
      if (!res) return
      // If the combo of products, format the data
      // 若商品的套餐，进行格式化数据
      if (res.type === 'combo') res = this._filterComboProduct(res)

      // Filter product data according to product inventory conditions
      // 根据商品库存条件，筛选商品数据
      res = this._filterPreOrderStockProduct(res)

      const upgradeProducts = (res.upgradeProducts instanceof Array || !res.upgradeProducts) ? null : res.upgradeProducts

      const data = {
        ...res,
        modifications: [
          ...res.modifications.map(item => {
            return {
              ...item,
              options: item.options.map(ls => {
                return {
                  ...ls,
                  isJardiniere: true,
                  isPlus: ls.adjustPrice,
                  number: ls.number || 0, // 初始化 number 为响应式属性，使 total computed 能追踪变化
                }
              }),
            }
          }),
        ],
        num: 1,
        upgradeProducts
      }
      // upgradeProducts - items，Each data is checked for selection
      // upgradeProducts - items，每条数据添加 checked，为了进行选中操作
      if (data.upgradeProducts?.items) {
        data.upgradeProducts.items.forEach(item => {
          item.price = item.price - parseFloat(data.price).toFixed(2)
          item.checked = false
        })
        // In case of online or takeaway environment, filter products
        // 若是 online 或 takeaway 环境，筛选出符合环境的对应商品
        if (this.isOnline || this.$route.path.includes('/o/')) data.upgradeProducts.items = data.upgradeProducts.items.filter(item => item.allowDelivery)
        if (!data.upgradeProducts?.items?.length) data.upgradeProducts = null
      }
      this.product = this._getAddRecommandProduct(data)
      this._applyDefaultSelectionLimits()
      this._getRequiredComboList()
      this._setMutipleSizeSettingsRealPrice()
      this._checkDefaultMutipleSize()
      this.saveProductName(getLocalizedField(res, 'name') || res.name)
    }
  }

  /**
   * Filter products in the combo
   * @param {Object} productData Product information
   * @returns {Object} Filtered product information
   */
  /**
   * 筛选套餐中的商品
   * @param {Object} productData 商品信息
   * @returns {Object} 过滤后的商品信息
   */
  _filterComboProduct(productData) {
    // ⚠️ 无论有没有套餐组都必须把商品**原样交回去**。以前 `return` 写在 `if` 里面，
    // 一个 `comboProducts` 为空的 combo 商品会让 `res = this._filterComboProduct(res)`
    // 变成 `undefined`，下一句 `_filterPreOrderStockProduct(undefined)` 当场抛，
    // 顾客看到的是一个永远转圈的商品详情页。
    let comboProducts = productData?.comboProducts ?? []
    if (comboProducts.length) {
      comboProducts = comboProducts.filter(comboProduct => {
        if (comboProduct.products.length) {
          // Filter the products off the shelf
          // 过滤掉下架商品
          const productList = comboProduct.products.filter(product => this._isShowProduct(product))
          if (productList.length) {
            // Reassign the filtered product list to the original data
            // 将过滤后的商品列表，重新赋值给原数据
            comboProduct.products = productList
            return true
          }
        }
        return false
      })
      // Reassign the filtered product list to the original data
      // 将过滤后的商品列表，重新赋值给原数据
      productData.comboProducts = comboProducts
    }
    return productData
  }

  /**
   * Whether to display products
   */
  /**
   * 是否显示商品
   */
  _isShowProduct(product) {
    const { status, allowDelivery, allowDinein, allowOnline, operatingHours } = product?.detail ?? product
    const isOnline = this.isOnline || this.$route.path.includes('/o/')
    // Judge whether the products are displayed in the delivery environment
    // 判断商品是否展示在外卖环境
    if (isOnline && !allowDelivery) return false
    // 按当前点单模式过滤推荐位：后端 2026-08-27 起在推荐项上带分类级模式旗
    // （allowDinein / allowOnline，缺键 = 放行，兼容旗子普及前的缓存）。
    // 没有这道门，dine-in 会展示只在 online/pickup 档分类里的推荐商品 ——
    // 顾客点进去加购的东西根本不在当前菜单里
    if (isOnline && allowOnline === false) return false
    if (!isOnline && allowDinein === false) return false
    return status && _isOpenStatus(operatingHours, 'sameAsProductGroup')
  }

  /**
   * Filter the inventory products of the pre-order
   * @param productData {Object} Commodity Details
   * @returns {Object} Filtered item details
   */
  /**
   * 筛选预定单的库存商品
   * @param productData {Object} 商品详情
   * @returns {Object} 过滤后的商品详情
   */
  _filterPreOrderStockProduct(productData) {
    if (productData.type === 'combo') { // Product type is combo   // 商品类型是套餐
      if (productData?.comboProducts?.length) { // There are products in the combo   // 套餐中存在商品
        const comboProducts = []
        productData.comboProducts.forEach(item => {
          if (item.type === 'required') { // If it is an optional product   // 若是可选商品
            // Filter out the products that do not meet the inventory conditions
            // 过滤掉不符合库存条件的商品
            const products = item.products.filter(product => this._checkStockProduct(product?.detail))
            // If the filtered products meet the group selection rules, add the latest data to comboProducts
            // 这个槽位还留不留得住。**§8 兜底之后这句话就等于「它还有没有子品」**：
            // 「正好选 N 样」配 M(< N) 个子品会被 §8.13 塌成「正好选 M 样」，
            // `range` 的下限同样被 ②½ 降到 M —— 必选槽位不能把同一个子品点两份
            // （`canIncreaseOption` 对 `type === 'required'` 早退，而且 `each.id < 0`
            // 那条模板分支压根不画 +/- 控件），所以 §8.15 那道「能加份的组不 clamp」
            // 的门在槽位上恒开。于是只要 M >= 1，槽位的下限恒 <= M，规则必定满足得了。
            // 等价性（不是「看起来对称」）由 productDetailComboSlotLimit.spec.js 的
            // 「§8 之后槽位的下限恒不超过子品条数」钉住 —— ②½ 哪天被改动，它先红。
            //
            // ⚠️ 以前这里写的是 `Number(item.minOption)`。**没写 `limitType` / 没写
            // `minOption` 的遗留槽位**（owner 2026-08-10 裁定 §9.1：没写档位一律当
            // 「正好选 1 样」）在那里拿到的是 `NaN`，`length >= NaN` 恒假 ——
            // 整个槽位在预定单里被**静默丢掉**，顾客买到一个少一件的套餐，屏上没有任何痕迹。
            //
            // ⚠️ 2026-08-11：判据从 `item.products`（**配置里**的条数）改成
            // `products`（**过滤后**的条数）。原写法的两边不是同一个数组 ——
            // 三个子品全部售罄时判据读到 3、推出去的是 `[]`，槽位于是以「空槽位」
            // 的形态活着：模板那道「这一组还有没有看得见的选项」的门让它一个像素
            // 都不画，`_validateRequiredModifications` 那道「选项不是全都看不见才
            // 写红字」的门又因为 `[].every()` 恒真而放行。
            // 结果是套餐少一件卖出去，屏上零痕迹。
            //
            // 新口径与**同一条链上的另外两处**一致，不是新发明的规矩：
            //   · `_filterComboProduct`（先跑）对「子品全被下架过滤光」的槽位
            //     就是 `return false` 整条丢掉；
            //   · 下面 `oneProduct` 那一支也是「有一样拿不到就整条丢掉」。
            // 另外这也让本行**真的**是一道门 —— 旧判据 `item.products.length` 在
            // `_filterComboProduct` 跑完之后恒为真（它已经把空槽位滤干净了），
            // 等于这行门从来没关过。
            //
            // 槽位的「子品条数」在本仓仍有两个口径、跨仓有三个（渲染那一侧数的是过滤后的
            // `options`；后端 `comboUnavailableReason` 数的是剔除下架/隐藏后的
            // `availableTotal`，而且下限读不出时 fail-open 整组跳过）——
            // 三个都只会让留下的槽位更多，不会凭空拦单，差异钉在那份用例的「口径」一条里。
            //
            // ⚠️ **`type === 'oneProduct'` 的槽位不走这一支，也不吃 §9.1**：它是固定包含的
            // 子品，后端要的是「提交条目数 == `products[]` 条数」而不是 1；本仓的
            // `isRequiredSection` 逐字比 `type === 'required'`，所以那种槽位算出来是
            // 「不限」而不是「正好 1 样」（同一份用例里单独钉了一节）。
            if (products.length) comboProducts.push({ ...item, products })
          } else if (item.type === 'oneProduct') { // If it is a required product   // 若是必选商品
            const isHaveStock = item?.products?.every(product => this._checkStockProduct(product?.detail))
            // Products that meet the inventory conditions are added to comboProducts
            // 满足库存条件的商品，添加到 comboProducts
            if (isHaveStock) comboProducts.push(item)
          }
        })
        productData.comboProducts = comboProducts
      }
    }

    if (productData.recommendationProducts?.length) { // If there is a list of recommendation products   // 若存在推荐商品列表
      const recommendationProducts = productData.recommendationProducts
      // Filter the products without inventory according to the recommendation product inventory corresponding to the specified date
      // 根据指定日期对应的推荐商品库存，过滤没有库存的商品
      productData.recommendationProducts = recommendationProducts.map(recommendationProduct => ({
        ...recommendationProduct,
        items: recommendationProduct.items.filter(item => this._checkStockProduct(item))
      }))
    }
    return productData
  }

  /**
   * Verify product inventory
   * @param product {Array} Verified product information
   * @returns {Boolean} Whether there is commodity inventory
   */
  /**
   * 校验商品库存
   * @param product {Array} 校验的商品信息
   * @returns {Boolean} 是否有商品库存
   */
  _checkStockProduct(product) {
    const stockSettings = product?.stockSettings
    // Determine whether the inventory of products is set
    // 判断商品是否设置库存
    if (stockSettings?.enableStockCount) {
      // Current remaining inventory quantity today
      // 今日当前剩余库存数量
      const currentStockCount = Number(stockSettings?.currentStockCount ?? 0)
      // Filter products without remaining quantity
      // 过滤没有剩余数量的商品
      return currentStockCount > 0
    }
    return true
  }

  // When editing product, select the result of the last size
  // edit product 时，选中上次 size 的结果
  _getChoosedRecommandProductMutipleSizeInfo() {
    const activeChoosedItemInfo = this.product.selectSize?.name
    if (activeChoosedItemInfo) {
      const choosedItemIndex = this.product.sizeSettings?.settings?.findIndex(item => item.name === this.product?.selectSize?.name)
      this.$refs.mutipleSize.chooseItem(choosedItemIndex, this.product.sizeSettings?.settings[choosedItemIndex])
    }
  }

  // Change the original price according to the rate
  // 根据 rate 更改原始价格
  _setMutipleSizeSettingsRealPrice() {
    if (this.enableMutipleSize) {
      this.product.sizeSettings.settings = this.product.sizeSettings?.settings?.map((item, index) => {
        return {
          index,
          ...item,
          price: parseFloat(item.price).toFixed(2)
        }
      })
    }
  }

  // Size selected by default
  // 默认选中 size
  _checkDefaultMutipleSize() {
    if (this.enableMutipleSize) {
      const defaultItem = this.product.sizeSettings?.settings?.find(item => item.default)
      if (defaultItem) {
        this.choosedItemInfo = defaultItem
        this.$refs.mutipleSize.choosedIndex = defaultItem.index
      }
    }
  }

  // Convert the list data of recommendations into the format of modifications
  // 把推荐菜列表数据转成配菜的格式
  _getFormatedToModificationsRecommandProductList(product) {
    const formatedRecommandProductList = []
    let num = 0

    // Filter out unsold products
    // 过滤掉无法售卖的商品
    const recommendationProducts = product.recommendationProducts.map(recommendationProduct => ({
      ...recommendationProduct,
      items: recommendationProduct.items.filter(item => this._isShowProduct(item))
    }))
    if (recommendationProducts.length) {
      // Consider a recommendation problem temporarily
      // 暂时考虑一个推荐菜品的问题
      recommendationProducts.forEach((each, index) => {
        // Build languages map with 'name' key from 'title'/'displayName'/'name' for localization support
        // 构建 languages 映射，将 'title'/'displayName'/'name' 映射为 'name' 以支持动态语言切换
        const languagesWithName = {}
        if (each.languages) {
          Object.keys(each.languages).forEach(lang => {
            languagesWithName[lang] = {
              ...each.languages[lang],
              name: each.languages[lang].title || each.languages[lang].displayName || each.languages[lang].name
            }
          })
        }
        const obj = {
          id: -1,
          limitType: 'limit',
          maxOption: '99', // Never show radio box   // 永远不显示单选框
          minOption: '99', // Never show radio box   // 永远不显示单选框
          name: each.title || each.displayName || each.name,
          languages: languagesWithName,
          removeType: false,
          recommendationType: true,
          type: 'optional',
          options: each.items.map((item, index) => {
            num++
            return {
              ...item,
              adjustPrice: parseFloat(item.price).toFixed(2),
              checked: this.recommandItemsChecked, // Can be set as the default check   // 可以设置为默认勾选
              disabled: this.isOnline ? !item.allowDelivery : false,
              order: index,
              unShow: this.isOnline ? !item.allowDelivery : false,
              number: item.number || 0,
            }
          }),
          operatingHours: each.operatingHours ?? { type: 'sameAsVenue' }
        }
        if (obj.operatingHours?.type === 'custom' && obj.operatingHours.customHours) {
          obj.unShow = !_isOpenStatus(obj.operatingHours, 'sameAsVenue')
        }
        formatedRecommandProductList.push(obj)
      })
    }
    this.recommandProductNum = num
    return formatedRecommandProductList
  }

  // Initialize the product obtained by the interface
  // 对接口获取的 product 进行初始化操作
  // Get a copy of the product after adding the recommendation
  // 获取添加推荐菜之后的 product 的副本
  _getAddRecommandProduct(data) {
    const formatedRecommandProductList = this._getFormatedToModificationsRecommandProductList(data)
    return {
      ...data,
      price: parseFloat(data.price).toFixed(2),
      modifications: [
        ...data.modifications.map(_getDefaultModificationsSettings),
        ...formatedRecommandProductList
      ]
    }

    function _getDefaultModificationsSettings(item) {
      // 可选组与必选组都认商家配的 default（owner 2026-08-12 拍板放开必选组，
      // 必选组既有交互不变：恒展开、不可取消到空、可以换选），
      // 而且一组最多认「有效上限」个 —— 多下发的、以及顾客看不见的一律不预勾选，
      // 见 sectionDefaultAllowance。这条路不保留已有勾选（整批按新菜单数据重来），
      // 所以不传 preserveRuntimeChecked，额度也就不预扣。
      const allowDefaultAt = sectionDefaultAllowance(item)
      return {
        ...item,
        options: item.options.map((each, index) => {
          const { checked, number } = resolveOptionSelection(each, { allowDefault: allowDefaultAt(index) })
          return {
            ...each,
            checked,
            disabled: false,
            number,
          }
        }),
        wrong: false,
      }
    }
  }

  /**
   * Re-check the "how many can I still pick" limits right after the pre-picked
   * options are applied, so options that are already unavailable are greyed out
   * from the start instead of looking tappable and doing nothing.
   * Only the greyed-out state is refreshed here — no error messages are shown
   * before the customer has touched anything.
   */
  /**
   * 预勾选写入后重算一次"还能不能再选"的限制，
   * 避免出现"看着能点、点了没反应"。只刷新置灰状态，
   * 不在顾客还没操作前就弹出提示文案。
   */
  _applyDefaultSelectionLimits() {
    const modifications = this.product?.modifications ?? []
    modifications.forEach(mod => applySectionSelectionLimits(mod))
  }

  /**
   * Template helpers — keep the collapse rules in one place so the main page and
   * the recommendation / combo pop-ups can never drift apart.
   */
  /**
   * 模板用的折叠规则代理，保证主商品页与推荐/套餐弹层不会各写一套
   */
  isSectionOpen(mod) {
    return isModSectionOpen(mod)
  }

  isSectionLocked(mod) {
    return isModSectionLocked(mod)
  }

  /**
   * 这一组一次只能选一样吗（要画成单选那种）。
   * 判据必须与点击处理、置灰、数量步进用的是同一个 —— 以前模板把上限字段
   * 拿去和字符串 "1" 硬比，遇到「恰好选 1 样」（上限只写在 minOption 上）
   * 或数字 1 的组就画成多选，屏幕上是复选框、点下去却按单选换选，自相矛盾。
   * Same predicate as the tap handling, greying and quantity steppers.
   * @param {Object} mod 配菜组
   * @returns {Boolean}
   */
  isSinglePickSection(mod) {
    return sectionIsSingleSelect(mod)
  }

  // Initialize the RecommandProduct obtained by the interface
  // 对接口获取的 RecommandProduct 进行初始化操作
  _getRecommandProduct(data) {
    const ls = []
    return {
      ...data,
      price: parseFloat(data.price).toFixed(2),
      modifications: data.modifications.map(item => {
        // 可选组与必选组都认商家配的 default（owner 2026-08-12 拍板放开必选组），
        // 而且一组最多认「有效上限」个 —— 多下发的、以及顾客看不见的一律不预勾选，
        // 已经勾着的份数先占额度（所以 preserveRuntimeChecked 要跟下面传一样的值），
        // 见 sectionDefaultAllowance
        const allowDefaultAt = sectionDefaultAllowance(item, { preserveRuntimeChecked: true })
        const options = item.options.map((each, index) => {
          // Already-made choices win (this runs again for combo items when the
          // customer edits a cart line). Only fresh options fall back to the
          // venue's pre-picked `default`.
          // 已有选择优先（编辑购物车里的套餐子品会再次走到这里），
          // 只有全新的选项才用商家配置的 default 预勾选
          const { checked, number } = resolveOptionSelection(each, {
            allowDefault: allowDefaultAt(index),
            preserveRuntimeChecked: true
          })
          return {
            ...each,
            checked,
            disabled: !!each.disabled,
            number,
          }
        })
        // 预勾选算进去之后重算一次置灰，避免"看着能点、点了没反应"
        // Recompute the greyed-out state once the pre-picked options are in.
        return applySectionSelectionLimits({
          ...item,
          options,
          wrong: false,
        })
      }),
      sizeSettings: {
        mutipleSize: data.sizeSettings?.mutipleSize ?? false,
        settings: data.sizeSettings?.settings?.map((item, index) => ({
          ...item,
          price: parseFloat(item.price).toFixed(2),
          onlinePrice: parseFloat(item?.onlinePrice ?? item.price).toFixed(2),
          index
        }))
      }
    }
  }

  // Save productName
  // 保存 productName
  saveProductName(productName) {
    this.$store.commit('saveNavTitle', {
      prop: 'productName',
      val: productName
    })
  }

  // Get the list of recommendations
  // 获取推荐菜列表
  async _getRecommandProductList() {
    const Recommand = this.product.modifications.filter(item => item.id < 0)
    if (Recommand.length) {
      const promisetList = []
      Recommand.forEach((item, index) => {
        item.options.forEach(async(each, i) => {
          if (item.isCombo) {
            this._getEveryRecommandProduct(each, Recommand, index, i, true)
          } else {
            const promise = this._getEveryRecommandProduct(each, Recommand, index, i, false)
            promisetList.push(promise)
          }
        })
      })
      await Promise.all(promisetList)
    }
  }

  async _getEveryRecommandProduct(each, Recommand, index, i, isCombo) {
    let res = each
    if (isCombo) {
      res = each.detail
    } else {
      const requestData = {
        id: each.id
      }
      const deliveryInfo = this.$store?.state?.contactDetails?.deliveryInfo[this.venueId] ?? {}
      // If it is a delivery system and a reservation order, the reservation date will be transferred to the interface
      // 若是外卖系统，并且是预定单，将预定日期传递给接口
      if (this.isOnline && deliveryInfo.preOrderTimeSettings) requestData.preOrderDate = dayjs(deliveryInfo.preOrderTimeSettings).format('YYYY-MM-DD')
    }

    this.recommandProductList.push(this._getRecommandProduct({
      ...res,
      num: 1
    }))

    this.recommandProductList = this.recommandProductList.map(item => {
      if (item.sizeSettings) {
        return {
          ...item,
          sizeSettings: {
            mutipleSize: item.sizeSettings?.mutipleSize ?? false,
            settings: item.sizeSettings?.settings?.map((item, index) => ({ ...item, index }))
          }
        }
      } else {
        return item
      }
    })

    if (!res.status) {
      Recommand[index].options[i].unShow = true
    }
  }

  // Format Combo Product Price
  // 格式化 Combo 商品价格
  _formatComboProduct() {
    this.product.comboProducts.forEach(combo => {
      combo.products.forEach(product => {
        // All size prices of single product are reset
        // 单品的 size 价格全部清零
        if (product.detail?.sizeSettings && product.detail?.sizeSettings?.mutipleSize) {
          product.detail.sizeSettings.settings.forEach(size => {
            size.price = 0
          })
          // Required products, default size is selected by default
          // 必选菜品，默认选中默认的 size
          if (combo.type === 'oneProduct') {
            const defaultSize = product.detail?.sizeSettings?.settings?.find(item => item.default)
            product.detail.selectSize = defaultSize
          }
        }
        // The deducted price of the modifications of the single product is all cleared to zero
        // 单品的减去的配菜价格全部清零
        const modificationList = product.detail?.modifications ?? []
        modificationList.forEach(modification => {
          if (modification.removeType) {
            modification.options.forEach(option => {
              option.adjustPrice = 0
            })
          }
        })
      })
    })
  }

  // Get Combo List
  // 获取 Combo 列表
  _getComboProductList() {
    const commandList = this.product.comboProducts
    const modifications = commandList.map((item, comboIndex) => ({
      ...item,
      // Get localized displayName with fallback / 获取本地化的 displayName（带回退）
      name: getLocalizedField(item, 'displayName') || item.name,
      id: item.type === 'required' ? -1 : '',
      options: item.products.map((products, productIndex) => ({
        ...products,
        // 这一格在整份套餐里的位置。`comboProductList` 是一条条 push 出来的
        // **位置列表**（同一个子品放两条就有两条记录），却一直按 id 取 ——
        // `find` 永远返回第一条，两格的配置于是写进同一条、两行小票一模一样。
        // 这个键让「格子 ↔ 记录」一一对上，见 `_comboProductForSlot`。
        // 纯客户端字段：进订单的那层 `_setProduct` 是白名单，带不出去。
        _comboSlot: `${comboIndex}:${productIndex}`,
        isCombo: this.isCombo && item.type === 'required',
        checked: item.type === 'oneProduct', // Can be set as the default check   // 可以设置为默认勾选
        disabled: false,
        unShow: false,
        number: products.number || 0,
      })),
      isCombo: this.isCombo && item.type === 'required',
      checked: this.recommandItemsChecked, // Can be set as the default check   // 可以设置为默认勾选
      disabled: false,
      unShow: false,
      adjustPrice: 0,
    }))
    this.product.modifications = [...modifications, ...this.product.modifications]
    if (commandList.length) {
      commandList.forEach((item, index) => {
        item.products.forEach(async(each, i) => {
          this._getEveryComboProduct(each, commandList, index, i)
        })
      })
    }
  }

  _getRequiredComboList() {
    this.requiredComboList = this.product?.modifications?.filter(item => item.type === 'oneProduct') ?? []
    if (this.requiredComboList.length > 0) {
      this.requiredComboList = this.requiredComboList.map(item => ({
        ...item,
        products: (item.options ?? item.products).map(product => ({
          ...product,
          detail: {
            ...product.detail,
            modifications: product.detail.modifications.map(mod => {
              // 可选组与必选组都认 default（owner 2026-08-12 拍板放开必选组），
              // 而且一组最多认「有效上限」个，看不见的选项不认也不占额度，
              // 已经勾着的份数先占额度，见 sectionDefaultAllowance
              const allowDefaultAt = sectionDefaultAllowance(mod, { preserveRuntimeChecked: true })
              const options = mod.options.map((option, index) => {
                // Keep what the customer already chose; only fresh options use
                // the venue's pre-picked `default`.
                // 保留顾客已有的选择，只有全新的选项才用 default 预勾选
                const { checked, number } = resolveOptionSelection(option, {
                  allowDefault: allowDefaultAt(index),
                  preserveRuntimeChecked: true
                })
                return {
                  ...option,
                  disabled: false,
                  unShow: false,
                  checked,
                  number,
                }
              })
              // 预勾选算进去之后重算一次置灰，套餐子品也要有，
              // 否则会出现"看着能点、点了没反应"。
              // Recompute the greyed-out state for combo items as well.
              return applySectionSelectionLimits({ ...mod, options })
            })
          }
        }))
      }))
    }
  }

  async _getEveryComboProduct(each, commandList, index, i) {
    const res = each.detail
    this.comboProductList.push(this._getRecommandProduct({
      ...res,
      // 这条记录属于哪一格 —— 与 `_getComboProductList` 盖在格子上的那个键同一套
      // 编号（组下标:组内下标）。两头都盖，`_comboProductForSlot` 才对得上。
      _comboSlot: `${index}:${i}`,
      recommendationProducts: [],
      num: 1
    }))

    this.comboProductList = this.comboProductList.map(item => {
      if (item.sizeSettings) {
        return {
          ...item,
          sizeSettings: {
            mutipleSize: item.sizeSettings?.mutipleSize ?? false,
            settings: item.sizeSettings?.settings?.map((item, index) => ({ ...item, index }))
          }
        }
      } else {
        return item
      }
    })

    // ⚠️ 既有债，只登记不改（不在本批范围内）——**但别再说它「到不了」**。
    // `commandList` 是 `this.product.comboProducts`，它的条目带的是 `products`，
    // **没有 `options`**（`options` 是 `_getComboProductList` 另外 map 出来的那份
    // `modifications`）。所以这一行一旦执行就是 `undefined[i]` 当场抛。
    //
    // 之前写过「`_filterComboProduct` 在这之前就滤掉了，实际到不了」—— 这个理由
    // **不成立**：`_filterComboProduct` 只在 `getData()` 的**非改单分支**跑；
    // created() 里的 **iframe 路径**直接 `_formatComboProduct() + _getComboProductList()`，
    // 两个过滤都不过，售罄子品（`status` 假）会真的走到这里。
    // 后果比看上去轻：本方法是 `async` 且调用方不 await，抛出去变成无人接的
    // rejected promise，push 与上面那次 `.map()` 都已经完成 —— 净效果是
    // 「iframe 路径下售罄子品没被标 `unShow`」，不是崩溃。
    if (!res.status) {
      commandList[index].options[i].unShow = true
    }
  }

  // Add the recommendation to the shopping cart temporary storage area independently
  // 把推荐菜单独添加到购物车暂存区
  _saveRecommandProductList() {
    const currentRecommandProductList = this.product.modifications.filter(item => item.id < 0 && !item.isCombo)
    if (!currentRecommandProductList.length) return

    currentRecommandProductList.forEach(every => {
      every.options.forEach(each => {
        if (each.checked) this._addEachRecommandProductToCart(each)
      })
    })
  }

  // Reconstruct the Combo format
  // 把 Combo 重构格式
  _saveComboProductList(product) {
    const modifications = []
    if (!product.modifications.length) return
    product.modifications.forEach(every => {
      const comboProduct = {
        name: every.name,
        type: every.type,
        itemList: []
      }
      every.options.forEach(each => {
        if (each.checked && (every.id < 0 ? every.isCombo : true)) {
          const item = _setProduct(this._addEachComboProductToCart(each))
          if (each.detail) {
            each.detail.selectSize = item?.selectSize ?? null
            item.containsTags = each.detail.containsTags ?? null
            // Carry seafood country-of-origin alongside containsTags so the
            // saved item keeps the same Seafood • {origin} label everywhere.
            // 把海鲜产地与 containsTags 一起带上，保存项各处保持 Seafood • {产地}。
            item.seafoodOrigin = each.detail.seafoodOrigin ?? null
            item.adjustPrice = each.adjustPrice
          }
          comboProduct.itemList.push(item)
        }
      })
      if (comboProduct.itemList.length) modifications.push(comboProduct)
    })
    product.comboProducts = modifications
  }

  // Reconstruct the format of upgradeProducts
  // 把 upgradeProducts 重构格式
  _saveUpgradeProducts() {
    const upgradeProduct = this.product.upgradeProducts?.items?.find(item => item.checked)
    if (!upgradeProduct) return
    const upgradeFromProductId = this.product.id
    this.product = {
      ...this.product,
      id: upgradeProduct.id,
      name: upgradeProduct.name,
      languages: upgradeProduct.languages || this.product.languages,
      image: upgradeProduct.image,
      upgradeFromProductId,
      upgradeProductContainsTags: upgradeProduct.containsTags
    }
  }

  _getRealProductPrice(product) {
    let basePrice = 0
    if (product?.selectSize?.name) {
      basePrice = parseFloat(product?.selectSize?.price ?? 0)
    } else {
      basePrice = parseFloat(product?.price ?? 0)
    }
    if (product?.modifications) {
      product.modifications.forEach(item => {
        item.options.forEach(each => {
          if (each.checked) basePrice += parseFloat(each?.adjustPrice ?? 0) * (each.number || 1)
        })
      })
    }
    return basePrice
  }

  /**
   * Calculation of total product price in shopping cart page editing combo
   * @param product {Object} The edited combo
   * @return {Number} Total combo price after editing
   */
  /**
   * 购物车页面，编辑套餐中商品总价格，价格计算
   * @param product {Object} 编辑过后的套餐
   * @return {Number} 编辑过后的套餐总价格
   */
  _getEditRealProductPrice(product) {
    let basePrice = 0
    if (this.choosedItemInfo && this.choosedItemInfo.price) {
      basePrice = parseFloat(this.choosedItemInfo.price)
    } else {
      basePrice = parseFloat(product.singlePrice)
    }
    basePrice += this.upgradeProductsPrice
    let oneProductPrice = 0 // Type is the total price of oneProduct with modifications to it (because the basic price of the combo previously calculated is less than the price of the modifications in it)   // type 是 oneProduct 且里面有配菜的商品的总价格(因为之前算的套餐基本价格少算了含有配菜的商品，所有在这里加上)
    product.modifications.forEach(item => {
      item.options.forEach(each => {
        // Type is the total price of oneProduct with side dishes in it (because the basic price of the set meal previously calculated is less than the price of the side dishes in it)
        // type 是 oneProduct 且里面有配菜的商品的总价格(因为之前算的套餐基本价格少算了含有配菜的商品，所有在这里加上)
        if (item.type === 'oneProduct') {
          oneProductPrice += this._requiredDishPrice(each)
        }
        // Calculate the total price of modifications
        // 计算配菜总价格（乘以选项数量）
        if (each.checked && item.id && !(item.id < 0)) {
          basePrice += parseFloat(each.adjustPrice) * (each.number || 1)
        }
        // Combo calculates the total price of optional products
        // combo 计算非必选菜总价
        if (each.checked && item.isCombo && item.id < 0) {
          basePrice += parseFloat(each.adjustPrice)
          // If this optional product modifications has a sub-item, look for the price of the sub-item in it
          // 如果这个非必选菜 modifications 有子项就去找里面子项的价格
          if (each.detail.modifications.length > 0) {
            each.detail.modifications.forEach(ls => {
              ls.options.forEach(op => {
                if (op.checked !== undefined) {
                  if (op.checked === true) {
                    basePrice += parseFloat(op.adjustPrice) * (op.number || 1)
                  }
                } else {
                  basePrice += parseFloat(op.adjustPrice) * (op.number || 1)
                }
              })
            })
          } else {
            basePrice += parseFloat(each.adjustPrice)
          }
        }
      })
    })
    basePrice = basePrice + oneProductPrice
    return basePrice
  }

  /**
   * Complete product price of the required products with modifications in the combo
   * @param product {Object} Required items
   * @return {Number} The total price of the required product side dishes
   */
  /**
   * 补全套餐中必选菜有配菜的商品价格
   * @param product {Object} 必选商品
   * @return {Number} 必选商品配菜的价钱总和
   */
  _requiredDishPrice(product) {
    let oneProductPrice = 0
    if (product.detail.modifications.length > 0) {
      product.detail.modifications.forEach(modifications => {
        modifications.options.forEach(options => {
          if (options.checked) {
            oneProductPrice += parseFloat(options.adjustPrice) * (options.number || 1)
          }
        })
      })
    }
    return oneProductPrice
  }

  // Use when there are recommendations in the recommendations
  // 在推荐菜中还有推荐菜的情况下使用
  _getRecommandProductPrice(product) {
    let adjustMoney = 0
    product.modifications.forEach(item => {
      item.options.forEach(each => {
        if (each.checked && item.id < 0) {
          if (item.removeType) {
            adjustMoney = adjustMoney + parseFloat(each.adjustPrice) * (each.number || 1)
          } else {
            adjustMoney = adjustMoney + parseFloat(each.adjustPrice) * (each.number || 1)
          }
        }
      })
    })
    return adjustMoney
  }

  // Form validation. If there is an option that fails, the corresponding prompt text will be displayed and the first error will be jumped to
  // 表单验证，若有没通过的选项，显示对应提示文字，并跳转到第一个错误
  _validateRequiredModifications() {
    this.product = {
      ...this.product,
      modifications: this.product.modifications.map((item, index) => {
        // 判据是**这一格自己的内容**，不是「在不在 passList 里」——
        // passList 只在顾客手点 getCheckNum 时才写入，required 组被 default 预选满足、
        // 或改单回填已经选够时，从来没走过 getCheckNum 也该放行，不该被当成"没填过"。
        // 与 verificationComboRequired（同文件）同一套判据：sectionLowerBound 是这组
        // 真正要选几样，calcSelectedTotal 是已经选了几样；全 unShow 的组谁都点不到，
        // 直接跳过（否则这个商品会变成永远加不进购物车）。
        // passList 机制本身不动（getCheckNum / initPassList / unPassIndexList 的滚动
        // 定位仍然用它），只是这道加购闸门不再问它。
        if (item.type === 'required' && !item.options.every(isOptionHidden) && sectionLowerBound(item) - calcSelectedTotal(item.options) > 0) {
          // `limitType` 归一化成 range / limit / exactly 三选一（见 utils/sectionLimit 的
          // `sectionLimitKind`）：**认不出来的值一律当 `exactly`**（owner 2026-08-10 裁定）。
          // 以前这条链直接比裸 `limitType`，没有 `else` —— 没写 limitType 的必选组
          // 一条校验都不跑，一样都不选照样加进购物车，屏幕上却写着「Required」。
          const limitKind = sectionLimitKind(item)
          let wrongMsg
          if (!item.options.every(option => option.unShow)) {
            if (limitKind === 'exactly') {
              // 念的是这一组真正被校验的那个数（有效上限，见 utils/sectionLimit.js），
              // 不是裸 minOption —— 两个键都没写出数时裸值会念成 `Select  (Required)`。
              // 这一支在 `item.type === 'required'` 里，所以有效上限一定是个正整数
              // （可选的 exactly 组是 NO_CAP，但它不做校验，也就没有这句提示）。
              wrongMsg = tParams('select_n_required', 'Select {n} (Required)', { n: sectionMaxOption(item) })
            } else if (limitKind === 'range') {
              // 两个数各自要「念得出」才念，唯一实现见 utils/sectionDesc 的 rangeCopy
              wrongMsg = rangeWrongCopy(item)
            } else if (limitKind === 'limit') {
              // 这一组的校验拦的是「一样都没选」，所以念「至少选 1 样」——
              // 以前念 `Select up to {minOption}`，而那个字段在 limit 组通常是 0 或空
              wrongMsg = limitWrongCopy()
            }
          }
          return {
            ...item,
            wrong: wrongMsg
          }
        } else {
          return {
            ...item,
          }
        }
      })
    }
  }

  // Add Cart
  // 添加购物车
  addCart() {
    this._validateRequiredModifications()
    // Whether to pass the form validation
    // 是否通过表单验证
    let isPassValidate = this.product.modifications.filter(item => item.wrong && !item.options.every(option => option.unShow)).length === 0
    if (this.isCombo) {
      // Whether it has passed the required modification verification of the required items
      // 是否通过必选单品的必选配菜验证
      // 闸门也逐子品问（第三个参数），否则同组第二个子品的漏配会被第一个的通行证盖住
      const isPassRequiredCombo = !this.requiredComboList.find((combo, comboIndex) => combo.products.find((product, productIndex) => this.verificationComboRequired(product.detail, comboIndex, productIndex)))
      isPassValidate = isPassValidate && isPassRequiredCombo
    }
    this.isPassValidate = isPassValidate
    if (isPassValidate) {
      if (this.disabledButton) return
      if (this.isCombo) this._saveComboProductList(this.product)
      // 升级商品，原 id
      if (this.$route.query.fromProductId) this.product.upgradeFromProductId = this.$route.query.fromProductId
      if (this.product.upgradeProducts) this._saveUpgradeProducts()
      // Whether the function is to add products or edit products
      // 功能是添加商品还是编辑商品
      const isEditProduct = !!this.$route.query.productId || Number(this.$route.query.productId) === 0
      if (this.$openreplayTracker) this.$openreplayTracker.event('add_to_cart')
      trackFunnelEvent('add_to_cart')
      if (this.$gtag) {
        this.$gtag.event('add_to_cart', {
          event_category: 'purchase_journey',
          event_label: 'Add To Cart',
        })
      }

      if (isEditProduct) {
        this._updateEditProduct()
        this._jumpToCart()
      } else {
        this._addNewProductToCart()
        // 从 cart AI 推荐跳转来的，加购后返回 cart
        if (this.$route.query.fromCart) {
          this._jumpToCart()
        } else {
          this._jumpToVenueHome()
        }
      }
      this._saveRecommandProductList()
    } else {
      this._scrollToErrorItem()
    }
  }

  // Add product to cart
  // 添加商品到购物车
  _addNewProductToCart() {
    const { index, ...choosedItemInfo } = this.choosedItemInfo
    const singlePrice = parseFloat(this.product.price) + parseFloat(this.product?.upgradeProducts?.items?.find(item => item.checked)?.price ?? 0)

    // 从 cart AI 推荐跳转过来时，从 sessionStorage 读取归因数据
    let aiAttribution = null
    let aiScene = ''
    let aiFromId = ''
    if (this.$route.query.fromCart && this.$route.query.aiSource) {
      try {
        const stored = sessionStorage.getItem('aiRecommendAttribution_' + this.product.id)
        if (stored) {
          aiAttribution = JSON.parse(stored)
          aiScene = 'cart'
          aiFromId = this.product.id
          sessionStorage.removeItem('aiRecommendAttribution_' + this.product.id)
        }
      } catch (e) { /* ignore */ }
    }

    // A/B test framework: also restore manual recAttribution if it was stashed before nav.
    // A/B 测试框架：如果跳转前暂存了人工推荐的 recAttribution，这里一并恢复。
    let recAttribution = this.product.recAttribution || null
    try {
      const storedRec = sessionStorage.getItem('pendingRecAttribution_' + this.product.id)
      if (storedRec) {
        recAttribution = JSON.parse(storedRec)
        sessionStorage.removeItem('pendingRecAttribution_' + this.product.id)
      }
    } catch (e) { /* ignore */ }

    const product = {
      ...this.product,
      price: parseFloat((this.total - this.recommandProductPrice).toFixed(2)),
      venueId: this.venueId,
      productGroupId: this.productGroupId,
      isAddItem: this._isPostPaidAddItem(),
      singlePrice,
      recommendFromProductId: null,
      aiRecommendFromProductId: aiFromId,
      aiRecommendScene: aiScene,
      aiRecommendAttribution: aiAttribution,
      // A/B test framework: parallel attribution slot for manual recommendations.
      // A/B 测试框架：人工推荐的归因字段，与 aiRecommendAttribution 并列。
      recAttribution: recAttribution,
      productGroupCourse: this.productGroupCourse,
      selectSize: choosedItemInfo,
      comboProductList: this.comboProductList,
    }
    if (product.upgradeProducts) product.upgradeProducts = null
    this.$store.commit('addNewProductToCart', product)
  }

  /**
   * Product data in the combo after editing the shopping cart page
   * Update data in vuex
   */
  /**
   * 购物车页面编辑后，套餐中商品数据
   * 更新 vuex 中的数据
   */
  _updateEditProduct() {
    const productIndex = this.$route.query.productId
    const { index, ...choosedItemInfo } = this.choosedItemInfo
    this.product.price = this.proList[productIndex].price
    const data = {
      ...this.product,
      price: parseFloat((this.total - this.recommandProductPrice).toFixed(2)),
      selectSize: choosedItemInfo,
      realProductPrice: this._getEditRealProductPrice(this.product),
      comboProductList: this.comboProductList
    }
    // console.log(data)
    this.$store.state.productList[productIndex] = data
  }

  _addEachRecommandProductToCart(each) {
    const currentRecommandProduct = this.recommandProductList.find(item => item.id === each.id)
    // If there are recommendations in the recommendations, enable the comment code under this function
    // 推荐菜里面还有推荐菜的情况，启用本函数下的注释代码
    // let res = this._getFormatedToModificationsRecommandProductList(currentRecommandProduct)
    // res = res.concat(currentRecommandProduct.modifications, res)
    const product = JSON.parse(JSON.stringify({
      ...currentRecommandProduct,
      price: parseFloat(currentRecommandProduct.price),
      venueId: this.venueId,
      productGroupId: this.productGroupId,
      isAddItem: this._isPostPaidAddItem(),
      singlePrice: parseFloat(currentRecommandProduct.price),
      num: this.product.num,
      recommendFromProductId: this.product.id,
      aiRecommendFromProductId: currentRecommandProduct._aiSource ? this.product.id : '',
      aiRecommendScene: currentRecommandProduct._aiSource ? 'product_detail' : '',
      aiRecommendAttribution: currentRecommandProduct._aiSource ? (currentRecommandProduct._aiAttribution || null) : null,
      // A/B test framework: parallel attribution slot for manual recommendations.
      // A/B 测试框架：人工推荐的归因字段，与 aiRecommendAttribution 并列。
      recAttribution: currentRecommandProduct.recAttribution || null,
      productGroupCourse: this.productGroupCourse,
      // Real price, including modifications and multipleSize
      // 真实的price，包含 modifications 与 mutipleSize
      realProductPrice: this._getRealProductPrice(currentRecommandProduct),
    }))
    if (product.type === 'combo') {
      let price = product.price
      price = price + this.recommendedDishesForGeneralCommodities(currentRecommandProduct)
      product.price = price
      product.realProductPrice = price
      this._saveComboProductList(product)
    }
    this.$store.commit('addNewProductToCart', product)
  }

  _addEachComboProductToCart(each) {
    // ⚠️ 按**这一格**取，不是按 id 取。下面那个 override 支几乎总是成立
    // （`_getRecommandProduct` 把 `checked` 归一成了布尔），所以真正进厨房的是
    // `comboProductSelectItem`；它按 id 取的时候，一个 oneProduct 组里的两条重复子品
    // 拿到的是同一条记录 —— 两行小票一模一样，「按下标写入」那条修复到不了这里。
    const comboProductSelectItem = this._comboProductForSlot(each)
    let currentRecommandProduct = each.detail ?? comboProductSelectItem
    if (
      comboProductSelectItem?.modifications &&
        comboProductSelectItem?.modifications[0]?.options[0]?.checked !== undefined
    ) {
      currentRecommandProduct = comboProductSelectItem
    }
    return {
      ...currentRecommandProduct,
      name: currentRecommandProduct?.name ?? each.name,
      isJardiniere: each.isJardiniere ?? '',
      isPlus: each.isPlus ?? 'noSideDish',
      adjustPrice: '',
      price: parseFloat(currentRecommandProduct?.price ?? 0),
      venueId: this.venueId,
      productGroupId: this.productGroupId,
      isAddItem: this._isPostPaidAddItem(),
      singlePrice: parseFloat(currentRecommandProduct?.price ?? 0),
      num: this.product.num,
      recommendFromProductId: this.product.id,
      recommendationProducts: [],
      productGroupCourse: this.productGroupCourse,
      // Real price, including modifications and multipleSize
      // 真实的price，包含 modifications 与 mutipleSize
      realProductPrice: this._getRealProductPrice(currentRecommandProduct),
    }
  }

  // Jump to homepage
  // 跳转到首页
  _jumpToVenueHome() {
    // Judge whether there is a table number and jump to the home page with parameter
    // 判断是否有桌号，是否带参数跳转到主页
    if (this.number) {
      this.$router.push({ path: `/v/${this.venueId}/home/t/${this.number}` })
    } else {
      if (this.routerInfo.noTable) {
        this.$router.push({ path: `/v/${this.venueId}/t` })
      } else {
        this.$router.push({ path: `/v/${this.venueId}/home/p` })
      }
    }
  }

  // Jump to shopping cart
  // 跳转到购物车
  _jumpToCart() {
    // Judge whether there is a table number and jump to the home page with parameter
    // 判断是否有桌号，是否带参数跳转到主页
    if (this.number) {
      this.$router.push({ path: `/v/${this.venueId}/cart/t/${this.number}` })
    } else {
      this.$router.push({ path: `/v/${this.venueId}/cart/p` })
    }
  }

  _isPostPaidAddItem() {
    // Obtain unPaidOrderNo and only pass a value for isAddItem
    // 获取 unPaidOrderNo 只为 isAddItem 传值
    const unPaidOrderNo = this.$store.state.venueUnpaidOrderList.find(item => item.venueId === this.venueId)?.unPaidOrderId ?? ''
    return this.routerInfo.paymentType === 'post-paid' && unPaidOrderNo
  }

  // Scroll to the first form error position
  // 滚动到第一个表单错误位置
  _scrollToErrorItem() {
    this.$nextTick(_ => {
      let targetDom = document.getElementsByClassName('error_red_text')
      // First, judge whether there are errors in the required modifications of combo's required items, and if there are no errors, jump to other errors
      // 先判断 combo 的必选单品的必选配菜是否有错误，若没有错误就跳转到其他的错误
      if (targetDom.length) {
        targetDom = targetDom[0]
      } else {
        // Get the offsetTop value of the index of the first unpassList
        // 获取第一个 unpassList 的 index 的 offsetTop 值
        const targetIndex = this.unPassIndexList[0]
        targetDom = document.getElementsByClassName('collapse_box')[targetIndex - this.requiredComboList.length]
      }
      if (targetDom) {
        const targetOffsetTop = targetDom.offsetTop
        const minusHeight = document.getElementsByClassName('van-collapse-item__title')[0].offsetHeight ?? 0
        window.scrollTo({
          top: targetOffsetTop - minusHeight,
          left: 0,
          behavior: 'smooth'
        })
      }
    })
  }

  /**
   * Judge whether it is a combo product
   * @param {Boolean} IsCombo of goods
   * @returns {Boolean} Is it a combo product
   */
  /**
   * 判断是否是套餐商品
   * @param {Boolean} 商品的 isCombo
   * @returns {Boolean} 是否是套餐商品
   */
  getIsCombo(val) {
    return !this._.isBoolean(val) || val
  }
}

export default productDetail
</script>
